$(function () {

    //弹出信息
    window.solution_msg = {

        //弹窗
        dialogBoxEl: document.querySelector('.act-dialog-box'),
        //toast
        toastBoxEl: document.querySelector('.act-toast-box'),

        //发送文件弹窗
        sedfileDialogBoxEl: document.querySelector('.act-sendfile-dialog'),
        //发送文件成功toast
        sedfileToastBoxEl: document.querySelector('.act-sendfile-toast-box'),

        //预览文件弹窗
        filePreviewBoxEl: document.querySelector('.act-file-preview-dialog'),
        videoBoxEl: document.querySelector('.dialog-video-box'),
        bargainEl: document.querySelector('.m-dialog-box'),
        loginEl: document.querySelector('#codeLogin'),
        miaoShaEl: document.querySelector('#miaoSha'),

        //公众号登录，绑定手机号弹层
        gzhBindMobile: document.querySelector('.gzh-bind-mobile'),

        //关联产品弹窗
        relatedEl: document.querySelector('.act-product-related-dialog'),

        //问卷提交成功弹窗
        surveyResultEl: document.querySelector('#submitModel'),

        //短视频详情页分享弹窗
        shortVideoShareEl: document.querySelector('.share-video-g'),

        //webinar2020 口令弹窗
        meetingsEl: document.querySelector('.webinar-meetings'),

        //推荐标签弹层
        recommendTagBoxEl: document.querySelector('.recommend-tag-dialog'),

        //订阅弹窗
        subscribeBoxEl: document.querySelector('.subscribe-dialog'),

        //提交成功弹层
        recommendTagSuccessBoxEl: document.querySelector('.recommend-tag-success-dialog'),

        //订阅计划开启弹层
        subscribePlanBoxEl: document.querySelector('.subscribe-plan-dialog'),

        //推荐文章弹层
        recommendArticleBoxEl: document.querySelector('.recommend-article-dialog'),

        //企点云MA推送弹窗
        maPushBoxEl: document.querySelector('.ma-push-dialog'),

        // 账户注销提示弹窗
        accountCancelBoxEl: document.querySelector('.act-account-cancel-dialog'),

        //toast
        toast: function (text, time) {
            var _this = this;

            _this.toastBoxEl = document.querySelector('.act-toast-box');
            var toastBoxEl = _this.toastBoxEl;
            var toastContentEL = toastBoxEl.querySelector('.toast-content');

            var s = time || 1500;

            toastContentEL.innerText = text ? text : '';

            show();

            setTimeout(function () {
                close();
            }, s);

            function show() {
                toastBoxEl.style.display = 'block';
                // toastBoxEl.classList.remove('dialog-mask-ani-fade-out');
                // toastBoxEl.classList.add('dialog-mask-ani-fade-in');
            }

            function close() {
                // toastBoxEl.classList.remove('dialog-mask-ani-fade-in');
                // toastBoxEl.classList.add('dialog-mask-ani-fade-out');
                setTimeout(function () {
                    toastBoxEl.style.display = 'none';
                }, 230);
            }

        },

        //提示窗没有取消按钮
        alert: function (text, confirm, cancel, title, isAlert) {
            this.dialog(text, confirm, cancel, title, true);
        },

        //提示窗
        dialog: function (text, confirm, cancel, title, isAlert, cancelText, confirmText, className) {

            var _this = this;
            var dialogBoxEl = _this.dialogBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var contentEL = dialogBoxEl.querySelector('.dialog-content');
            var titleEL = dialogBoxEl.querySelector('.dialog-title');
            var confirmEl = dialogBoxEl.querySelector('.act-dialog-bt-confirm');
            var cancelEl = dialogBoxEl.querySelector('.act-dialog-bt-cancel');
            var closeEl = dialogBoxEl.querySelector('.act-dialog-close');


            if (typeof confirm !== "function") {
                confirm = function () {
                };
            }
            if (typeof cancel !== "function") {
                cancel = function () {
                };
            }

            //设置信息
            titleEL.innerText = title ? title : '';
            contentEL.innerHTML = text ? text : '';
            cancelEl.innerText = cancelText ? cancelText : '取消';
            confirmEl.innerText = confirmText ? confirmText : '确定';
            if (isAlert) {
                dialogBoxEl.querySelector('.act-dialog-bt-cancel').classList.add('hide');
            }

            //设置样式
            if (className) {
                dialogEl.classList.add(className);
            }

            //显示
            show();

            confirmEl.addEventListener('click', funcConfirm);

            cancelEl.addEventListener('click', funcCancel);
            closeEl.addEventListener('click', close);
            maskEl.addEventListener('click', close);

            // 确认
            function funcConfirm() {
                confirm();
                close();
            }


            // 取消
            function funcCancel() {
                cancel();
                close();
            }

            function show() {

                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                    //移除样式
                    if (className) {
                        dialogEl.classList.remove(className);
                    }
                }, 230);

                //移除事件
                confirmEl.removeEventListener('click', funcConfirm);

                cancelEl.removeEventListener('click', funcCancel);
                closeEl.removeEventListener('click', close);
                maskEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },

        //发送文件弹窗
        dialogSedfile: function (text, email, confirm, cancel, title) {

            var _this = this;
            var dialogBoxEl = _this.sedfileDialogBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var contentEL = dialogBoxEl.querySelector('.dialog-content');
            var titleEL = dialogBoxEl.querySelector('.dialog-title');
            var confirmEl = dialogBoxEl.querySelector('.act-dialog-bt-confirm');
            var cancelEl = dialogBoxEl.querySelector('.act-dialog-bt-cancel');
            var closeEl = dialogBoxEl.querySelector('.act-dialog-close');
            var inputEl = dialogBoxEl.querySelector('.dialog-input>input');
            var errorEl = dialogBoxEl.querySelector('.dialog-input-error');


            if (typeof confirm !== "function") {
                confirm = function () {
                };
            }
            if (typeof cancel !== "function") {
                cancel = function () {
                };
            }

            //设置信息
            titleEL.innerText = title ? title : '';
            if (text) {
                contentEL.innerText = text;
            }
            inputEl.value = email;

            //显示
            show();

            confirmEl.addEventListener('click', send);

            closeEl.addEventListener('click', close);
            maskEl.addEventListener('click', close);

            //监听邮箱输入框
            inputEl.addEventListener('keyup', verificationEmail);

            //确认发送
            function send() {
                if (!verificationEmail(inputEl.value)) {
                    return;
                }
                confirm(inputEl.value);
                close();
            }

            //验证邮箱
            function verificationEmail() {
                var email = inputEl.value;
                if (!email.match(/^\w+[\w\-\.]*@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]{2,})+$/)) {
                    inputEl.style.border = '1px solid #ff5959';
                    errorEl.style.display = 'block';
                    return false;
                } else {
                    inputEl.style.border = '1px solid #e9eef4';
                    errorEl.style.display = 'none';
                    return true;
                }
            }

            function show() {

                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                    errorEl.style.display = 'none';
                    inputEl.style.border = '1px solid #e9eef4';
                }, 230);

                //移除事件
                confirmEl.removeEventListener('click', send);
                closeEl.removeEventListener('click', close);
                maskEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },


        //发送文件成功toast
        toastSedfile: function (text, time) {
            var _this = this;
            _this.sedfileToastBoxEl = document.querySelector('.act-sendfile-toast-box');
            var toastBoxEl = _this.sedfileToastBoxEl;
            var toastContentEL = toastBoxEl.querySelector('.toast-text');

            var s = time || 1500;

            if (text) {
                toastContentEL.innerText = text;
            }

            show();

            setTimeout(function () {
                close();
            }, s);

            function show() {
                toastBoxEl.style.display = 'block';
                // toastBoxEl.classList.remove('dialog-mask-ani-fade-out');
                // toastBoxEl.classList.add('dialog-mask-ani-fade-in');
            }

            function close() {
                // toastBoxEl.classList.remove('dialog-mask-ani-fade-in');
                // toastBoxEl.classList.add('dialog-mask-ani-fade-out');
                setTimeout(function () {
                    toastBoxEl.style.display = 'none';
                }, 230);
            }

        },

        //预览文件弹窗
        filePreviewDialog: function (url, title, needLogin, articleId, fileIds, fileName, articleUrl, hiddenDown, previewUrl, leftPageNum) {
            var _this = this;
            var dialogBoxEl = _this.filePreviewBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog-filepre-content');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var titleEL = dialogBoxEl.querySelector('.file-action-bar>.title>a>h2');
            var titleLinkEL = dialogBoxEl.querySelector('.file-action-bar>.title>a');
            var closeEl = dialogBoxEl.querySelector('.closeicon');
            var iframeEl = dialogBoxEl.querySelector('.file-preview-box>iframe');
            var likeEl = dialogBoxEl.querySelector('.like');
            var likeIconEl = dialogBoxEl.querySelector('.like-icon');
            var downEl = dialogBoxEl.querySelector('.downicon');
            var collectType = $('.act-like-' + articleId).attr('data-status');
            var pageNumEl = dialogBoxEl.querySelector('.file-page-num');
            var bottomBar = dialogBoxEl.querySelector('.file-action-bottom-bar');

            //动态设置iframe内容高度
            var iframeBoxEl = dialogBoxEl.querySelector('.file-preview-box');
            // var h = window.innerHeight * 0.85;
            // iframeBoxEl.style.height = h + 'px';

            //设置点赞状态
            getCollectionStatus(articleId, likeEl);
            //如果articleId 不存在则隐藏点赞按钮
            if (!articleId) {
                likeEl.classList.add('hide');
            }

            //文件点赞功能
            likeEl.classList.add('act-like-' + articleId);
            likeEl.setAttribute('data-id', articleId);
            likeEl.setAttribute('data-title', title);
            likeEl.setAttribute('data-status', collectType);
            likeIconEl.classList.add('status-like-' + collectType);

            //设置信息
            if (title === '0') {
                title = '';
            }

            if (hiddenDown === '1') {
                downEl.classList.add('hide');
            } else {
                downEl.classList.remove('hide');
            }

            if(leftPageNum){
                pageNumEl.innerText = leftPageNum;
            }
            // 判断是否显示底部的剩余页数 需要登录 未登录 包含预览链接 剩余页数不为0
            if(needLogin && !isLogin() && previewUrl && parseInt(leftPageNum)){
                bottomBar.style.display = 'block';
                iframeEl.setAttribute('src', previewUrl);
            }else{
                bottomBar.style.display = 'none';
                iframeEl.setAttribute('src', url);
            }

            titleEL.innerText = title ? title : '';


            //设置标题跳转链接
            if (articleUrl) {
                titleLinkEL.setAttribute('target', '_blank');
                titleLinkEL.setAttribute('href', articleUrl);
            } else if (articleId && articleId !== '0' && window.cateData.pageModule !== 'detail') {
                titleLinkEL.setAttribute('target', '_blank');
                titleLinkEL.setAttribute('href', window.urlConfig.type + window.urlConfig.baseUrl + '/view-' + articleId + '.html');
            } else {
                titleLinkEL.setAttribute('href', 'javascript:void(0)');
            }


            //显示
            show();

            closeEl.addEventListener('click', close);
            maskEl.addEventListener('click', close);

            downEl.addEventListener('click', down);

            // 下载
            function down() {
                filelist.download(fileIds, articleId, title, needLogin, fileName);
            }

            function show() {

                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                    //关闭后将url置空
                    iframeEl.setAttribute('src', '');
                    titleLinkEL.setAttribute('href', 'javascript:void(0)');
                    //判断是否是我喜爱的内容弹窗
                    if (window.cateData.pageSubModule == 'favorite' && $.cookie('cancelCollect')) {
                        $.cookie('cancelCollect', '', {expires: -1}); // 删除 cookie
                        window.location.reload();
                    }
                }, 230);

                //移除事件
                closeEl.removeEventListener('click', close);
                maskEl.removeEventListener('click', close);
                downEl.removeEventListener('click', down);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },

        //预览视频弹窗
        videoDialog: function (url, title, articleId, articleUrl, autoPlay, noRecord) {
            var _this = this;
            var dialogBoxEl = _this.videoBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog-video-content');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var titleEL = dialogBoxEl.querySelector('.video-action-bar>.title>a>h2');
            var titleLinkEL = dialogBoxEl.querySelector('.video-action-bar>.title>a');
            var closeEl = dialogBoxEl.querySelector('.closeicon');
            var videoEl = dialogBoxEl.querySelector('.video-box>video');
            var likeEl = dialogBoxEl.querySelector('.like');
            var likeIconEl = dialogBoxEl.querySelector('.like>.like-icon');
            var collectType = $('.act-like-' + articleId).attr('data-status');

            //设置点赞状态
            getCollectionStatus(articleId, likeEl);

            //如果articleId 不存在则隐藏点赞按钮
            if (!articleId) {
                likeEl.classList.add('hide');
            }

            //视频点赞功能
            likeEl.classList.add('act-like-' + articleId);
            likeEl.setAttribute('data-id', articleId);
            likeEl.setAttribute('data-title', title);
            likeEl.setAttribute('data-status', collectType);
            likeIconEl.classList.add('status-like-' + collectType);

            //设置信息
            titleEL.innerText = title ? title : '';
            videoEl.setAttribute('src', url);

            //设置标题跳转链接
            if (articleUrl) {
                titleLinkEL.setAttribute('target', '_blank');
                titleLinkEL.setAttribute('href', articleUrl);
            } else if (articleId) {
                titleLinkEL.setAttribute('target', '_blank');
                titleLinkEL.setAttribute('href', window.urlConfig.type + window.urlConfig.baseUrl + '/view-' + articleId + '.html');
            } else {
                titleLinkEL.setAttribute('href', 'javascript:void(0)');
            }


            //显示
            show();

            closeEl.addEventListener('click', close);
            maskEl.addEventListener('click', close);

            function show() {

                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //Google、Safari 兼容自动播放
                if (autoPlay && (navigator.userAgent.indexOf('Chrome') > -1 || navigator.userAgent.indexOf('Safari') > -1)) {
                    //如果是谷歌浏览器
                    setTimeout(function () {
                        if (!videoEl.paused) {
                            return;
                        }
                        console.log("fhsodfhs", videoEl.paused);
                        msg.dialog('是否允许本页中的音/视频自动播放？', function () {
                            var timer = null;

                            function autoPlay() {
                                console.log(videoEl.paused);
                                if (videoEl.paused) { //如果暂停
                                    videoEl.paused = false;//设为不暂停
                                    videoEl.play();//调用play（）方法播放
                                } else {//如果未暂停
                                    clearInterval(timer);//清掉定时器
                                }
                            }

                            timer = setInterval(autoPlay, 1000);//用定时器触发autoplay自动播放
                        }, function () {
                            close();
                        }, '提示信息：')
                    }, 1000)


                } else {
                    videoEl.play();
                }


                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                    //判断是否是我喜爱的内容弹窗
                    if (window.cateData.pageSubModule == 'favorite' && $.cookie('cancelCollect')) {
                        $.cookie('cancelCollect', '', {expires: -1}); // 删除 cookie
                        window.location.reload();
                    }
                }, 230);

                videoEl.pause();
                if (!noRecord) {
                    gioTrackAction.cloudEndPlayVideo(videoEl.currentTime || 0, articleId, title);
                }
                videoEl.setAttribute('src', '');
                titleLinkEL.setAttribute('href', 'javascript:void(0)');

                closeEl.removeEventListener('click', close);
                maskEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },


        /**
         * 议价单
         * @param productInfo 产品信息
         * @param formConfig 表单配置
         * @param gioClickEvent gio点击事件标识符
         */
        bargainDialog: function (urlData, formConfig, gioClickEvent) {
            var _this = this;
            if (gioClickEvent) {
                gio('track', gioClickEvent);
            }

            //如果没有传过来配置，则用批量议价单的配置
            var formConfig = formConfig || window.cateData.batchFrome;

            //设置产品信息
            var productInfoDef = {
                productname: '',
                productImg: '',
                productDesc: '',
                productnum: '1',
                productnumLimit: '9999',
                productprice: '',
                productid: '',
                productType: '' // 型号
            };
            var info = $.extend(productInfoDef, urlData);
            _this.bargainEl = document.querySelector('.m-dialog-box');
            var dialogBoxEl = _this.bargainEl;

            var dialogEl = dialogBoxEl.querySelector('.m-bargain-content');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var closeEl = dialogBoxEl.querySelector('.close-modal');
            var confirmEl = dialogBoxEl.querySelector('.submit-bargain-btn');
            var kefuEl = dialogBoxEl.querySelector('.act-kefu');

            //显示
            show();

            closeEl.addEventListener('click', close);
            maskEl.addEventListener('click', close);
            confirmEl.addEventListener('click', send);
            kefuEl.addEventListener('click', openKefu);

            var bargainPro = document.querySelector('.m-bargain-pro');
            var bargainProName = document.querySelector('.bargain-pro-name');
            var bargainProDesc = document.querySelector('.bargain-pro-desc');
            var bargainProImg = document.querySelector('.bargain-pro-picture img');
            var bargainProPrice = document.querySelector('.bargain-pro-buy .cur-price');
            var bargainProNum = document.querySelector('.j-num-input2');
            var bargainPriceLabel = document.querySelector('.j-price-label');
            var bargainDelPrice = document.querySelector('.del-price');
            var bargainFormTitle = document.querySelector('.dialog-bargain-title');
            var bargainFormDesc = document.querySelector('.dialog-bargain-tip');
            var bargainProTypeWrap = document.querySelector('.j-pro-type');
            var bargainProType = bargainProTypeWrap.querySelector('.pro-type');

            bargainFormTitle.innerText = formConfig.formName || '';
            if (formConfig.formDesc) {
                bargainFormDesc.innerText = formConfig.formDesc;
            }

            // 自定义提交按钮背景颜色
            if (formConfig.submitBGColor) {
                confirmEl.setAttribute('style', 'background:' + formConfig.submitBGColor);
            } else {
                confirmEl.setAttribute('style', 'background:#f2af29');
            }

            if (urlData && urlData.productid) {
                bargainPro.style.display = 'flex';
                bargainProImg.src = urlData.productImg || '';
                // bargainProNum.value = info.productnum || '';
                bargainProName.innerText = urlData.productname || '';
                bargainProDesc.innerText = urlData.productDesc || '';
                bargainProPrice.innerText = urlData.productprice || '';
                bargainPriceLabel.innerText = urlData.salePrice ? '促销价格' : '参考价格';
                if (urlData.salePrice && urlData.unSalePrice) {
                    bargainDelPrice.innerText = urlData.unSalePrice;
                    bargainDelPrice.classList.remove('hide');
                }
                bargainProImg.setAttribute('alt', urlData.productname);

                if(info.productnum >= info.productnumLimit){
                    info.productnum = info.productnumLimit;
                }
                if(info.productnumLimit == 0){
                    bargainProNum.value = 0;
                }else{
                    bargainProNum.value = 1;
                }
                var numIn = numInput('.j-num-input2', '.j-plus02', '.j-minus02', info.productnumLimit);
                numIn.setInputVal(parseInt(info.productnum));
                if (urlData.productType) {
                    bargainProTypeWrap.style.display = 'block';
                    bargainProType.innerText = urlData.productType;
                }
            } else {
                bargainPro.style.display = 'none';
            }

            // 初始化表单
            var formName = new fieldHandle.HandelValue('dialogName', 'dialogNameV', 'dialogNameVE', 'form-error', '请输入姓名');
            var formMobile = new fieldHandle.HandelValue('dialogMobile', 'dialogMobileV', 'dialogMobileVE', 'form-error', '请输入手机', '输入正确的手机号', baseVerif.isMobile);
            var formEmail = new fieldHandle.HandelValue('dialogEmail', 'dialogEmailV', 'dialogEmailVE', 'form-error', '请输入邮箱', '输入正确的邮箱', baseVerif.isEmail);
            var formCompName = new fieldHandle.HandelValue('dialogCompName', 'dialogCompV', 'dialogCompVE', 'form-error', '请输入公司名称');
            var formIfwish = new fieldHandle.HandelRadioVerif('ifWish', 'dialogIfWishVE');

            //设置表单默认值
            formName.set(getUserInfo.options.name || '');
            formMobile.set(getUserInfo.options.mobile || '');
            formEmail.set(getUserInfo.options.email || '');
            formCompName.set(getUserInfo.options.enterpriseName || '');
            formIfwish.setNull();

            function openKefu() {
                // common.productOpenKefu(info.productid);
                qidiankefu.open('',{
                    productId :info.productid
                });
            }

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top'
                );
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');

                bargainDelPrice.classList.add('hide');

                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);
                closeEl.removeEventListener('click', close);
                maskEl.removeEventListener('click', close);
                confirmEl.removeEventListener('click', send);
                kefuEl.removeEventListener('click', openKefu);

                //允许后方滚动
                common.setScroll.removeUnScroll();
                if (numIn) {
                    numIn.destroy();
                }
                numIn = null
            }

            //清空表单对象
            function clearFomr() {
                //指控表单对象
                formName = null;
                formMobile = null;
                formEmail = null;
                formCompName = null;
                formIfwish = null;
            }

            //确认发送
            function send() {
                //进行验证
                formName.change();
                formMobile.change();
                formEmail.change();
                formCompName.change();
                formIfwish.change();
                if (formName.isVerif && formMobile.isVerif && formEmail.isVerif && formCompName.isVerif && formIfwish.isVerif) {
                    //进行验证
                    var url = window.cateData.api.actionForm;
                    var parainfo = {
                        customFormId: formConfig.formId,
                        globalUserId: getUserInfo.options.globalUserId,
                        instanceId: '',
                        items: [
                            {fieldName: "enterprise_name", value: formCompName.get()},
                            {fieldName: "name", value: formName.get()},
                            {fieldName: "mobile", value: formMobile.get()},
                            {fieldName: "email", value: formEmail.get()},
                            {fieldName: "ifWish", value: formIfwish.get()},
                            {fieldName: formConfig.customFilds.productName, value: info.productname},
                            {fieldName: formConfig.customFilds.productId, value: info.productid},
                            {fieldName: formConfig.customFilds.productPrice, value: info.productprice},
                            {fieldName: formConfig.customFilds.productNum, value: numIn ? numIn.getInputVal() : ''},
                            {
                                fieldName: formConfig.customFilds.linkSourceModule,
                                value:  (window.cateData.userRecordOption &&  window.cateData.userRecordOption.module )? window.cateData.userRecordOption.module : ''
                            },
                            {fieldName: formConfig.customFilds.pagetitle, value: document.title},
                            {fieldName: "linksource", value: window.location.href},
                        ],
                        linkId: '',
                        sess: window.cateData.userInfo.sess,
                        referenceUrl: '',
                        url: window.location.href,
                        ver: "v2.0.1",
                    };
                    postJson(url, parainfo, function (data) {
                        var userR = {behaviorType: formConfig.behaviorType};
                        if (data.body.result === 0) {
                            userR['behaviorResult'] = info.productname;
                            if (formConfig.entrance) {
                                userR['entrance'] = formConfig.entrance;
                            }
                            solution_msg.toastSedfile('提交成功！请等待戴尔销售专家与您联系！', 3000);
                            userRecord(userR);
                            if (formConfig.gioType) {
                                gio('track', formConfig.gioType, {
                                    'phoneNumber': common.mobileEncryption(formMobile.get()) || '',
                                    'productname': info.productname || '',
                                    'ibuyEntrancePageTitle': document.title,
                                    'ibuyEntrancePageURL': document.URL,
                                    'productID': info.productid || '',
                                    'linkSourceurl': window.location.href || '',
                                });  //埋点实施方案
                            }

                        } else {
                            msg.toast('提交失败,请稍后再试');
                            userR['behaviorResult'] = "提交失败";
                            userRecord(userR);
                        }

                        clearFomr();
                    });
                    close();
                }
            }
        },
        // 公用项目咨询配置
        /**
         *
         * @param gioClickEvent gio点击事件标识符
         * @constructor
         */
        ProjectConsultingDialog: function (gioClickEvent) {
            var _this = this;
            _this.bargainDialog(null, window.cateData.purchaseIntentionForm, gioClickEvent);
        },

        // 验证码登录弹窗
        codeLoginDialog: function (code) {
            var _this = this;
            var dialogBoxEl = _this.loginEl;
            var dialogEl = dialogBoxEl.querySelector('.m-login-content');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var inputEl = dialogBoxEl.querySelector('.form-control-input');
            var confirmEl = dialogBoxEl.querySelector('.dialog-confirm-btn');
            var errorTip = dialogBoxEl.querySelector('.error-tip');

            confirmEl.addEventListener('click', login);

            show();

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');

                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                    window.location.reload();
                }, 230);
                confirmEl.removeEventListener('click', login);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }

            function login() {
                if (!inputEl.value || $.trim(inputEl.value).toUpperCase() != code.toUpperCase()) {
                    errorTip.innerText = inputEl.value ? '*验证码无效' : '*请输入验证码';
                    errorTip.style.display = 'block';
                    return;
                }
                $.cookie('verify_code', inputEl.value, {expires: 7, domain: '.dellemc-solution.com'});
                close();
            }
        },

        // 秒杀弹窗
        miaoShaDialog: function (msDetailId) {
            var _this = this;
            var dialogBoxEl = _this.miaoShaEl;
            var dialogEl = dialogBoxEl.querySelector('.m-miaosha-content');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var closeEl = dialogBoxEl.querySelector('.m-ms-close');
            var qiangGouEl = dialogBoxEl.querySelector('.ms-qianggou-btn');
            var codeEl = dialogBoxEl.querySelector('.miaosha-code');
            var errorTipsEl = dialogBoxEl.querySelector('.ms-error-tip');
            var successCon = dialogBoxEl.querySelector('.j-successCon');
            var failCon = dialogBoxEl.querySelector('.j-failCon');
            var codeCon = dialogBoxEl.querySelector('.j-codeCon');

            closeEl.addEventListener('click', close);
            qiangGouEl.addEventListener('click', qiangGou);

            show();

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();

                //gio 埋点
                try {
                    gio('track', 'double12miaoshabutton_click', {'consultEntrancePage': document.title, 'consultEntrancePageURL': document.URL})
                }catch (e) {
                    console.log(e)
                }
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');

                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                closeEl.removeEventListener('click', close);
                qiangGouEl.removeEventListener('click', qiangGou);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }

            var isSubmitting = false;
            function qiangGou() {
                if (isSubmitting) return;
                if (codeEl.value == '') {
                    errorTipsEl.innerText = '请输入兑换码';
                    return;
                }
                isSubmitting = true;
                errorTipsEl.innerText = '';
                var url = '/api/miaosha/doaward?award_id=' + msDetailId + '&code=' + codeEl.value;
                getJson(url, '', function (data) {
                    isSubmitting = false;
                    if (data.errCode == '0') {
                        codeCon.style.display = 'none';
                        successCon.style.display = 'block';
                    } else if (data.errCode == '40101') {
                        errorTipsEl.innerText = '您的兑换码输入有误，请重新输入';
                    } else if (data.errCode == '40102') {
                        errorTipsEl.innerText = '您的抢购码已被兑换，不可重复使用';
                    } else {
                        codeCon.style.display = 'none';
                        failCon.style.display = 'block';
                    }
                    if(app){
                        app.getInfo();
                    }
                });
            }
        },

        //提示窗
        relatedDialog: function (title, highLight, imgUrl, price, confirm, closeFunc) {

            var _this = this;
            var dialogBoxEl = _this.relatedEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var highlinghtEl = dialogBoxEl.querySelector('.highlinght');
            var priceEl = dialogBoxEl.querySelector('.price-content');
            var titleEl = dialogBoxEl.querySelector('.title');
            var confirmEl = dialogBoxEl.querySelector('.act-dialog-bt-confirm');
            var closeEl = dialogBoxEl.querySelector('.act-dialog-close');
            var countBoxEl = dialogBoxEl.querySelector('.dialog-close-time');
            var countEl = countBoxEl.querySelector('.count-time');


            if (typeof confirm !== "function") {
                confirm = function () {
                };
            }

            if (typeof closeFunc !== "function") {
                closeFunc = function () {
                };
            }

            //设置信息
            titleEl.innerHTML = title ? title : '';
            highlinghtEl.innerHTML = highLight ? highLight : '';
            priceEl.innerHTML = price ? price : '联系戴尔';
            dialogBoxEl.querySelector('.prod-img img').src = imgUrl;


            //显示
            show();

            confirmEl.addEventListener('click', funcConfirm);
            maskEl.addEventListener('click', close);
            closeEl.addEventListener('click', close);

            if (getUserInfo.getUserTeam() == 4 || getUserInfo.getUserTeam() == 5) {
                closeEl.style.display = 'none';
                countBoxEl.style.display = 'block';
                var timer = setInterval(function () {
                    var curTime = countEl.innerText;
                    if (curTime <= 1) {
                        close();
                        clearInterval(timer);
                    } else {
                        countEl.innerText = curTime - 1;
                    }
                }, 1000);
            }

            // 确认
            function funcConfirm() {
                confirm();
                close();
            }

            function show() {

                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                //移除事件
                confirmEl.removeEventListener('click', funcConfirm);
                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();

                closeFunc();
            }
        },

        //问卷成功提示弹窗
        surveyDialog: function () {
            var _this = this;
            var dialogBoxEl = _this.surveyResultEl;
            var dialogEl = dialogBoxEl.querySelector('.m-survey-submit-content');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');

            show();

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }
        },

        dialogDtf: function (opt) {

            var text = opt.title || '',
                desc = opt.desc || '',
                showCloseBtn = opt.showCloseBtn || true,
                linkText = opt.linkText || '',
                linkUrl = opt.linkUrl  || 'javascript:void(0)',
                linkTarget = opt.openNew?'_blank':'self',
                className = opt.className || '',
                icon = opt.icon || '/catalog/view/theme/default/img/layer-wait-pic.png',
                closeFunc = opt.closeFunc || '';


            var _this = this;

            //获取元素
            var dialogBoxEl = document.querySelector('.act-dialog-box-dtf');
            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var closeEl = dialogBoxEl.querySelector('.act-dialog-close');
            var linkEl = dialogBoxEl.querySelector('.btn-link');
            var iconEl = dialogBoxEl.querySelector('.dialog-icon img');

            if(!showCloseBtn){
                closeEl.style.display = 'none';
            }

            linkEl.innerHTML = linkText;
            linkEl.setAttribute('href', linkUrl);
            linkEl.setAttribute('target', linkTarget);
            iconEl.setAttribute('src', icon);

            if(className){
                dialogBoxEl.classList.add(className);
            }

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                if (text) {
                    var titleEL = dialogEl.querySelector('.text-big');
                    titleEL.innerHTML = text;
                }

                var descEL = dialogEl.querySelector('.text-desc');
                if (desc) {
                    descEL.style.display = '';
                    descEL.innerHTML = desc;
                }else{
                    descEL.style.display = 'none';
                }

                if(showCloseBtn){
                    maskEl.addEventListener('click', close);
                    closeEl.addEventListener('click', close);
                }

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();

                if (typeof closeFunc === "function") {
                    closeFunc();
                }
            }

            function goHome() {
                window.location.href = window.rootUrl;
            }

            show();

            return {
                'close': close
            }
        },

        // 账户注销提示：统一弹窗
        accountCancelAlert: function () {
            var _this = this;
            var dialogBoxEl = _this.accountCancelBoxEl;
            if (!dialogBoxEl) { return; }

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var confirmEl = dialogBoxEl.querySelector('.dialog-bt-confirm');
            var closeEl = dialogBoxEl.querySelector('.act-dialog-close');

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                if (common && common.setScroll && typeof common.setScroll.unScroll === 'function') {
                    common.setScroll.unScroll();
                }
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                //移除事件
                confirmEl && confirmEl.removeEventListener('click', close);
                closeEl && closeEl.removeEventListener('click', close);
                maskEl && maskEl.removeEventListener('click', close);

                //允许后方滚动
                if (common && common.setScroll && typeof common.setScroll.removeUnScroll === 'function') {
                    common.setScroll.removeUnScroll();
                }
            }

            show();
            confirmEl && confirmEl.addEventListener('click', close);
            closeEl && closeEl.addEventListener('click', close);
            maskEl && maskEl.addEventListener('click', close);
        },

        /**
         * 短视频分享弹窗
         * @param videoInfo 短视频信息
         * */
        videoShareDialog: function (videoInfo) {
            var _this = this;
            var dialogBoxEl = _this.shortVideoShareEl;

            var dialogEl = dialogBoxEl.querySelector('.share-box');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var closeEl = dialogBoxEl.querySelector('.share-video-close');

            // 作者信息和视频信息
            var authorAvatar = dialogBoxEl.querySelector('.author-avatar');
            var authorName = dialogBoxEl.querySelector('.author-name');
            var videoCover = dialogBoxEl.querySelector('.cover-img');
            var videoSummary = dialogBoxEl.querySelector('.video-summary');
            var videoLink = dialogBoxEl.querySelector('.address-link');
            var linkFoo = dialogBoxEl.querySelector('#linkFoo');

            if (videoInfo) {
                videoCover.src = videoInfo.cover;
                videoSummary.innerText = videoInfo.title;
                authorAvatar.src = videoInfo.avatar;
                authorName.innerText = videoInfo.nickName;
                videoLink.href = videoInfo.addressLink;
                videoLink.innerText = videoLink.href;
                linkFoo.value = videoLink.href;
                $("#qrcode").html("");
                var qr = $("#qrcode").qrcode({
                    width: $("#qrcode").width(),
                    height: $("#qrcode").height(),
                    correctLevel: 1,
                    text: videoInfo.addressLink
                });

                var clipboard = new Clipboard('.copy-link-button');

                clipboard.on('success', function(e) {
                    console.log(e);
                });

                clipboard.on('error', function(e) {
                    console.log(e);
                });

            }

            function show() {

                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }

            closeEl.addEventListener('click', close);

            //显示
            show();
        },

        /**
         * webinar2020 口令弹窗
         * @param password 口令密码
         */
        webinar2020Dialog: function () {
            var _this = this;
            var dialogBoxEl = _this.meetingsEl;

            var dialogEl = dialogBoxEl.querySelector('.meetings-box');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var closeEl = dialogBoxEl.querySelector('.webinar-box-close');
            var errorEl = dialogBoxEl.querySelector('.error-tip');

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');
                errorEl.innerHTML = '';
                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }

            closeEl.addEventListener('click', close);

            //显示
            show();
        },

        /* 对比弹窗 */
        compareDialog: function () {
            var dialogBoxEl = document.querySelector('#compareWrapper');
            var closeEl = dialogBoxEl.querySelector('.close-compare-box');

            function show() {
                dialogBoxEl.classList.remove('ani-to-bottom');
                dialogBoxEl.classList.add('ani-form-bottom');
                dialogBoxEl.style.display = 'block';
            }

            function close() {
                dialogBoxEl.classList.remove('ani-form-bottom');
                dialogBoxEl.classList.add('ani-to-bottom');
                setTimeout(function() {
                    dialogBoxEl.style.display = 'none';
                }, 230);
            }

            closeEl.addEventListener('click', close);
            show();
        },

        // 轻注册完善信息后跳转抽奖的弹窗
        lightRegToLucky: function (closeFunc) {
            var gotoLuckTimer = setTimeout(function () {
                lightRegDialog.close();
                window.location.href = 'https://smarket.dellemc-solution.com/u/vNyrv2';
            }, 5000);

            var clearTimer = function () {
                if( typeof closeFunc === 'function'){
                    closeFunc();
                }
                clearTimeout(gotoLuckTimer);
            };

            var lightRegDialog = this.dialogDtf({
                title:'会员注册已完成',
                desc:'5s后自动跳转到抽奖页面，<br>关闭弹窗将视为自动放弃抽奖资格',
                linkText:'点击抽奖',
                linkUrl: window.cateData.linghtRegLuckyLink,
                openNew: true,
                icon: 'https://emc-image.dellemc-solution.com/web_images/dialog_to_lucky_title_icon.png',
                className: 'dialog-light-reg-to-lucky',
                closeFunc: clearTimer
            });
        },

        // 推荐标签弹窗
        recommendTagDialog: function () {
            var _this = this;
            var dialogBoxEl = _this.recommendTagBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var confirmEl = dialogBoxEl.querySelector('.dialog-bt-confirm');
            var closeEl = dialogBoxEl.querySelector('.dialog-bt-cancel');
            var tagBoxEl = dialogBoxEl.querySelector('.dialog-content .scroll-view');

            if (!common.isLogin()) {
                return common.gotoLogin();
            }

            // 初始化表单
            var formMobile = new fieldHandle.HandelValue('dialogCompleteMobile', 'dialogCompleteMobileV', 'dialogCompleteMobileVE', 'form-error', '请输入手机号', '输入正确的手机号', baseVerif.isMobile);
            var formCompanyEmail = new fieldHandle.HandelValue('dialogCompleteCompanyEmail', 'dialogCompleteCompanyEmailV', 'dialogCompleteCompanyEmailVE', 'form-error', '请输入企业邮箱', '输入正确的企业邮箱', baseVerif.isEmail);

            //设置表单默认值
            formMobile.set(getUserInfo.options.mobile || '');
            formCompanyEmail.set(getUserInfo.options.email || '');

            tagsData().then(function () {
                // 显示
                show();
                gioTrackAction.gio_base('popupImp', {'popupType_var': '订阅兴趣弹窗'});
                // 点击标签 切换选中的样式
                $('.recommend-tag-dialog .scroll-view .label').click(function () {
                    $(this).toggleClass('label-selected');
                });
            });

            confirmEl.addEventListener('click', funcConfirm);
            maskEl.addEventListener('click', close);
            closeEl.addEventListener('click', close);

            // 标签数据
            function tagsData() {
                var def = $.Deferred();
                var info = {
                    OCSESSID: common.isLogin() ? common.isLogin().OCSESSID : '',
                    session: common.isLogin() ? common.isLogin().session : '',
                };
                var tagStr = '';

                common.getJson(solution_host + '/api/account/tag', info, function (res) {
                    if (common.getSS('recommend_tag_list', true)) {
                        // 登录后返回，回填选中的标签
                        res.data.forEach(function(item) {
                            item.tag.forEach(function (tag) {
                                common.getSS('recommend_tag_list', true).forEach(function (ss_tag) {
                                    if (tag.id == ss_tag) {
                                        tag.select = true;
                                    }
                                })
                            });
                        });
                        sessionStorage.removeItem('recommend_tag_list');
                    }
                    res.data.forEach(function(item) {
                        tagStr += '<section class="filter-list__module" id="'+ item.summary +'"><div class="module-list__title">' + item.title +'</div>' + '<ul class="module-list">';
                        item.tag.forEach(function (tag) {
                            tagStr += '<li class="module-list__item"><div data-id="' + tag.id + '" class="label ' + (tag.select ? 'label-selected' : '') +'">' + tag.title + '</div></li>'
                        });
                        tagStr += '</ul></section>';
                    });
                    tagBoxEl.innerHTML = tagStr;
                    def.resolve();
                });
                return def;
            }

            // 确认
            function funcConfirm() {
                var tagIdList = $('.recommend-tag-dialog .scroll-view .label-selected').map(function(){
                    return ($(this).attr('data-id'));
                }).get();
                if (!common.isLogin()) {
                    if (tagIdList.length > 0) {
                        common.setSS('recommend_tag_list', tagIdList, true);
                    }
                    return common.gotoLogin();
                }
                if (tagIdList.length === 0) return msg.toast('请选择标签');
                //进行验证
                formMobile.change();
                formCompanyEmail.change();

                if (formMobile.isVerif && formCompanyEmail.isVerif) {
                    // 处理埋点数据
                    var productsName =  $('#interestProductMA .label-selected').map(function(){
                        return ($(this).text());
                    }).get().join(',');
                    var solutionName =  $('#interestSolutionMA .label-selected').map(function(){
                        return ($(this).text());
                    }).get().join(',');
                    var allTagsName =   $('.recommend-tag-dialog .scroll-view .label-selected').map(function(){
                        return ($(this).text());
                    }).get().join(',');
                    gioTrackAction.gio_base('interestSubmit', {'interestProduct':productsName, 'interestSolution':solutionName, 'subType':''});
                    userAction.interestTagSelect(allTagsName);

                    common.postJson(solution_host + '/api/account/likeTag', {
                        session: common.isLogin() ? common.isLogin().session : '',
                        OCSESSID: common.isLogin() ? common.isLogin().OCSESSID: '',
                        tag: tagIdList,
                        email: formCompanyEmail.value,
                        mobile: formMobile.value,
                        source: 'pc'
                    }, function (res) {
                        common.setCookie('recommend_tag', true);
                    });
                    close();
                    window.solution_msg.recommendTagSuccessDialog();
                }
            }

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                //移除事件
                confirmEl.removeEventListener('click', funcConfirm);
                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },

        // 推荐标签成功后弹窗
        recommendTagSuccessDialog: function () {
            var _this = this;
            var dialogBoxEl = _this.recommendTagSuccessBoxEl;
            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var closeEl = dialogBoxEl.querySelector('.dialog-close');

            // 显示
            show();
            maskEl.addEventListener('click', close);
            closeEl.addEventListener('click', close);

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                //移除事件
                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },

        // 订阅计划开启弹窗
        subscribePlanDialog: function () {
            var _this = this;
            var dialogBoxEl = _this.subscribePlanBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var dialogBtn = dialogBoxEl.querySelector('.dialog-btn');
            var closeEl = dialogBoxEl.querySelector('.dialog-close');

            show();

            closeEl.addEventListener('click', close);
            maskEl.addEventListener('click', close);
            dialogBtn && dialogBtn.addEventListener('click', goCampaign);

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                // 订阅计划已弹出
                common.setCookie('subscribePlanClick_20260226', 1, 365);
                gioTrackAction.gio_base('popupClose', {
                    "in_app_message_name": "会员礼遇A类弹窗"
                });

                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                //移除事件
                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);
                dialogBtn && dialogBtn.removeEventListener('click', goCampaign);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }

            function goCampaign() {
                close();
                gioTrackAction.gio_base('PopUp_HuiyuanLiyu_Button', {
                    "in_app_message_name": "会员礼遇A类弹窗"
                });
                window.location.href = window.solution_host + '/campaign/promotion'
            }
        },

        // 文章推荐弹窗
        recommendArticleDialog: function () {
            var _this = this;
            var swiper_new;
            var dialogBoxEl = _this.recommendArticleBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var closeEl = dialogBoxEl.querySelector('.dialog-close');
            var swiperBoxEl = dialogBoxEl.querySelector('.swiper-wrapper');



            articleData().then(function (res) {
                if(res.length === 0) return;
                // 显示
                show();
                // 初始化swiper
                initSwiper();
            });

            maskEl.addEventListener('click', close);
            closeEl.addEventListener('click', close);

            // 标签数据
            function articleData() {
                var def = $.Deferred();
                var info = {
                    OCSESSID: common.isLogin() ? common.isLogin().OCSESSID : '',
                    session: common.isLogin() ? common.isLogin().session : '',
                };
                var swiperStr = '';

                common.getJson(solution_host + '/api/account/tagArticle', info, function (res) {
                    console.log(res.data);
                    res.data.forEach(function(item) {
                        swiperStr += '<div class="swiper-slide">' +
                            '<div class="article-item">' +
                            '<a href="'+ item.linkUrl +'" target="_blank">' +
                            '<div class="cover-img">' +
                            '<img src="' + item.coverImageUrl +'" alt="">' +
                            '</div>' +
                            '<div class="article-title">' + item.title +'</div>' +
                            '</a>' +
                            '</div></div>';
                    });
                    swiperBoxEl.innerHTML = swiperStr;
                    def.resolve(res.data);
                });
                return def;
            }

            function initSwiper() {
                swiper_new = new Swiper('.recommend-article-dialog .article-swiper', {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 20,
                    observer:true,
                    observeParents:true,
                    pagination: {
                        clickable: true,
                        el: '.swiper-recommend-pagination'
                    },
                })
            }

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                //移除事件
                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);

                //销毁swiper
                swiper_new.destroy(false);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },

        // 企点云MA推送弹窗pi
        maPushDialog: function (img, url, id) {
            return;
            var _this = this;
            var dialogBoxEl = _this.maPushBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var closeEl = dialogBoxEl.querySelector('.dialog-close');

            if(!img){
                return;
            }

            // 设置一个cookie 弹出后，第二天再弹出
            common.setCookie('maPushDialogCookie', 1, 1);


            _this.show(dialogBoxEl);

            closeEl.addEventListener('click', close);
            maskEl.addEventListener('click', close);

            // 给 ma-push-dialog-img 添加图片
            dialogBoxEl.querySelector('.ma-push-dialog-img').src = img;

            // 给 ma-push-dialog-img 添加链接
            if(url){
                dialogBoxEl.querySelector('.ma-push-dialog-img').onclick = function () {
                    gioTrackAction.gio_base('MAsolutionpopover_Click');
                    common.gotoUrl(url);
                }
            }

            function close() {
                // 订阅计划已弹出
                common.getJson(solution_host + '/api/qi_cloud/close', {id:id}, function (res) {
                    console.log('关闭成功', res)
                });
                gioTrackAction.gio_base('MAsolutionpopover_closedClick');
                _this.close(dialogBoxEl);
                closeEl.removeEventListener('click', close);
                maskEl.removeEventListener('click', close);
            }
        },

        // 公众号登录，绑定手机号
        bindMobileDialog: function (successFunc) {
            var _this = this;
            var dialogBoxEl = _this.gzhBindMobile;
            var dialogEl = dialogBoxEl.querySelector('.bind-form');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var codeBtnEl = dialogBoxEl.querySelector('.get-phone-code');
            var confirmEl = dialogBoxEl.querySelector('.bind-form-btn');
            var sending = false; // 短信发送中
            var downTime = 60; // 短信倒计时
            var submiting = false; // 点击提交

            // 显示
            show();

            confirmEl.addEventListener('click', submit);
            codeBtnEl.addEventListener('click', send);

            // 初始化表单
            var formMobile = new fieldHandle.HandelValue('dialogBindMobile', 'dialogBindMobileV', 'dialogBindMobileVE', 'form-error', '请输入手机号', '输入正确的手机号', baseVerif.isMobile);
            var formCode = new fieldHandle.HandelValue('dialogBindMobileCode', 'dialogBindMobileCodeV', 'dialogBindMobileCodeVE', 'form-error', '请输入验证码', '输入正确的验证码', baseVerif.isNum);

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');

                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                confirmEl.removeEventListener('click', submit);
                codeBtnEl.removeEventListener('click', send);

                clearFomr();

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }

            //清空表单对象
            function clearFomr() {
                //指控表单对象
                formMobile = null;
                formCode = null;
            }

            //发送验证码
            function send() {
                formMobile.change();
                if (formMobile.isVerif && !sending) {
                    //手机号验证通过
                    codeBtnEl.innerHTML = '发送中...';
                    codeBtnEl.classList.remove('pointer');
                    sending = true;

                    common.postJson(solution_host + '/api/sms/code/send',{
                        unique: formMobile.get(),
                        sign: common.getSendCodeSign(),
                        action: ''
                    },function (data) {
                        if (data.errCode === 0) {
                            downTime = 60;
                            var timer = setInterval(function () {
                                downTime--;
                                codeBtnEl.innerHTML = downTime + ' S';
                                if (downTime == 0) {
                                    codeBtnEl.innerHTML = '重新发送';
                                    codeBtnEl.classList.add('pointer');
                                    clearInterval(timer);
                                    timer = null;
                                    sending = false;
                                }
                            },1000)
                        } else {
                            msg.toast(data.msg);
                            codeBtnEl.innerHTML = '重新发送';
                            codeBtnEl.classList.add('pointer');
                            sending = false;
                        }
                    })
                }
            }

            //绑定手机号
            function submit() {
                //进行验证
                formMobile.change();
                formCode.change();

                submiting = true;
                confirmEl.innerHTML = '绑定中...';

                if (formMobile.isVerif && formCode.isVerif) {
                    submiting = true;
                    confirmEl.innerHTML = '绑定中...';
                    common.postJson(solution_host + '/api/account/loginandregister',{
                        "unique": formMobile.get(),
                        "checkCode": formCode.get(),
                        "unikey": localStorage.getItem('unikey'),
                        "url": window.location.href,
                        "globalUserId": common.getGlobalUserId(),
                        "moduleSource": common_utmObj.modulesources || '',
                        "utm_source": common_utmObj.utm_source || '',
                        "utm_medium": common_utmObj.utm_medium || '',
                        "utm_campaign": common_utmObj.utm_campaign || '',
                        "utm_content": common_utmObj.utm_content || '',
                        "utm_term": common_utmObj.utm_term || ''
                    }, function (data) {
                        submiting = false;
                        confirmEl.innerHTML = '绑定手机号';
                        if (data.errCode !== 0) return _this.toast(data.msg);
                        try {
                            // gio 埋码
                            var giouserinfo = data.data;
                            var gioParams = {
                                phone_ppl: common.mobileGioEncryption(data.data.mobile),
                            }
                            gio('setUserId', data.data.memberId);
                            gio('people.set',gioParams);
                            //cookie中设置一个用户手机
                            common.setCookie('dell_userName', data.data.name|| '', 5);
                            common.setCookie('dell_userMobile', common.mobileEncryption(data.data.mobile), 5);
                            common.setCookie('Activity_MOBILE','MOBILE'+ data.data.mobile +'number', 365);
                            gio('track', 'loginSuccess', {'user_Id': data.data.memberId, 'phoneNumber': common.mobileGioEncryption(data.data.mobile),'loginType':'微信扫码'})
                            _this.toast('绑定成功');
                            common.setCookie('smarketMember_498', JSON.stringify({
                                session: data.data.session,
                                memberId: data.data.memberId || '',
                                email: data.data.email || ''
                            }), 5);
                            common.setCookie('OCSESSID', data.data.OCSESSID, 5);
                        } catch (e) {
                            console.log(e);
                        }
                        setTimeout(function(){
                            window.location.reload();
                        },500)
                        localStorage.removeItem('unikey');
                        close();
                    });
                }
            }
        },

        // 公用显示
        show: function (dialogBoxEl) {
            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');

            dialogBoxEl.style.display = 'flex';
            maskEl.classList.remove('dialog-mask-ani-fade-out');
            dialogEl.classList.remove('dialog-ani-to-top');
            maskEl.classList.add('dialog-mask-ani-fade-in');
            dialogEl.classList.add('dialog-ani-from-top');

            //禁止后方滚动
            common.setScroll.unScroll();
        },

        // 公用关闭
        close: function (dialogBoxEl) {
            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');

            maskEl.classList.remove('dialog-mask-ani-fade-in');
            maskEl.classList.add('dialog-mask-ani-fade-out');

            dialogEl.classList.remove('dialog-ani-from-top');
            dialogEl.classList.add('dialog-ani-to-top');
            setTimeout(function () {
                dialogBoxEl.style.display = 'none';
            }, 230);
            //允许后方滚动
            common.setScroll.removeUnScroll();
        },

        // 订阅弹窗
        subscribeDialog: function(gioName){
            if (gioName) {
                gioTrackAction.gio_base('DingYuePianHao_Click', {
                    DingYuePianHao_Point: gioName
                });
            }
            var _this = this;
            var dialogBoxEl = _this.subscribeBoxEl;
            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var dialogSuccessEl = dialogBoxEl.querySelector('.dialog-success');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var confirmEl = dialogBoxEl.querySelector('.save-btn');
            var closeEl = dialogBoxEl.querySelector('.dialog-close');
            var closeEl2 = dialogBoxEl.querySelector('.dialog-close2');
            var tagBoxEl = dialogBoxEl.querySelector('.category-list');
            if (!common.isLogin()) {
                return common.gotoLogin();
            }
            loadData().then(function () {
                // 显示
                show();
                // 点击标签 切换选中的样式
                $('.subscribe-dialog .tag-list .tag-item').click(function () {
                    $(this).toggleClass('item-checked');
                });
            });

            confirmEl.addEventListener('click', funcConfirm);
            // maskEl.addEventListener('click', close);
            closeEl.addEventListener('click', close);
            closeEl2.addEventListener('click', close);

            // 标签数据
            function loadData() {
                var def = $.Deferred();
                var info = {
                    OCSESSID: common.isLogin() ? common.isLogin().OCSESSID : '',
                    session: common.isLogin() ? common.isLogin().session : '',
                };
                var tagStr = '';

                common.getJson(solution_host + '/api/subscribe/subjects', info, function (res) {
                    res.data.forEach(function (item) {
                        tagStr += '<div class="category-item"> <div class="category-name">' + item.category + '</div><div class="tag-list">'
                        item.children.forEach(function (tag) {
                            tagStr += '<div data-id="' + tag.id + '" class=" tag-item ' + (tag.subscribed ? 'item-checked' : '') +' ">' + tag.title + '</div>'
                        })
                    });
                    tagStr += '</div></div>'
                    tagBoxEl.innerHTML = tagStr;
                    def.resolve();
                })
                return def;
            }

            // 确认
            function funcConfirm() {
                var tagIdList = $('.subscribe-dialog .tag-list .item-checked').map(function(){
                    return ($(this).attr('data-id'));
                }).get();
                if (tagIdList.length === 0) return solution_wap_msg.toast('请选择标签');
                var subscribe_position = common.getCookie('subscribe_position') ? common.getCookie('subscribe_position'): '' ;
                let info = {
                    session: common.isLogin().session ,
                    OCSESSID: common.isLogin().OCSESSID,
                    id: tagIdList,
                    position: subscribe_position
                }
                common.postJson(solution_host + '/api/subscribe', info,function (result) {
                    if (result.errCode === 0) {
                        dialogEl.style.display = 'none';
                        dialogSuccessEl.style.display = 'block'
                    }else{
                        solution_wap_msg.toast('订阅失败');
                    }
                    common.setCookie('subscribe_position','')
                });
            }

            function show() {
                dialogBoxEl.style.display = 'flex';
                dialogEl.style.display = 'block';

                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                common.setCookie('subscribe_position','')
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                    dialogSuccessEl.style.display = 'none'
                }, 230);

                //移除事件
                confirmEl.removeEventListener('click', funcConfirm);
                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);
                closeEl2.removeEventListener('click', close);
                //允许后方滚动
                common.setScroll.removeUnScroll();
            }

        },
    };


    window.solution_wap_msg = {

        //弹窗
        dialogBoxEl: document.querySelector('.act-dialog-box'),
        //toast
        toastBoxEl: document.querySelector('.act-toast-box'),

        //发送文件弹窗
        sedfileDialogBoxEl: document.querySelector('.act-sendfile-dialog'),
        //发送文件成功toast
        sedfileToastBoxEl: document.querySelector('.act-sendfile-toast-box'),

        //预览文件弹窗
        filePreviewBoxEl: document.querySelector('.act-file-preview-dialog'),
        videoBoxEl: document.querySelector('.dialog-video-box'),

        //公众号登录，绑定手机号弹层
        gzhBindMobile: document.querySelector('.gzh-bind-mobile'),

        //批量议价弹窗
        bargainEl: document.querySelector('.act-dialog-bargain-box'),

        loginWithCodeBoxEl: document.querySelector('.act-codelogin-dialog'),

        //底部上拉菜单
        upPullList:document.querySelector('.act-dialog-box-select'),

        //产品选择型号
        productTypeSelectEl: document.querySelector('.act-product-select'),

        //秒杀
        miaoShaEl: document.querySelector('#miaoSha'),

        //关联产品弹窗
        relatedEl: document.querySelector('.act-product-related-dialog'),

        //webinar2020 口令弹窗
        meetingsEl: document.querySelector('.webinar-meetings'),

        //推荐标签弹层
        recommendTagBoxEl: document.querySelector('.recommend-tag-dialog'),

        //提交成功弹层
        recommendTagSuccessBoxEl: document.querySelector('.recommend-tag-success-dialog'),

        //订阅计划开启弹层
        subscribePlanBoxEl: document.querySelector('.subscribe-plan-dialog'),

        //推荐文章弹层
        recommendArticleBoxEl: document.querySelector('.recommend-article-dialog'),

        //toast
        toast: function (text, time) {
            var _this = this;

            var toastBoxEl = _this.toastBoxEl;
            var toastContentEL = toastBoxEl.querySelector('.toast-content');

            var s = time || 1500;

            toastContentEL.innerText = text ? text : '';

            show();

            setTimeout(function () {
                close();
            }, s);

            function show() {
                toastBoxEl.style.display = 'block';
                toastBoxEl.classList.remove('dialog-mask-ani-fade-out');
                toastBoxEl.classList.add('dialog-mask-ani-fade-in');
            }

            function close() {
                toastBoxEl.classList.remove('dialog-mask-ani-fade-in');
                toastBoxEl.classList.add('dialog-mask-ani-fade-out');
                setTimeout(function () {
                    toastBoxEl.style.display = 'none';
                }, 230);
            }

        },

        //提示窗没有取消按钮
        alert: function (text, confirm, cancel, title, isAlert) {
            this.dialog(text, confirm, cancel, title, true);
        },

        //提示窗
        dialog: function (text, confirm, cancel, title, isAlert, cancelText, confirmText, className) {

            var _this = this;
            var dialogBoxEl = _this.dialogBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var contentEL = dialogBoxEl.querySelector('.dialog-content');
            var titleEL = dialogBoxEl.querySelector('.dialog-title');
            var confirmEl = dialogBoxEl.querySelector('.act-dialog-bt-confirm');
            var cancelEl = dialogBoxEl.querySelector('.act-dialog-bt-cancel');
            var closeEl = dialogBoxEl.querySelector('.act-dialog-close');


            if (typeof confirm !== "function") {
                confirm = function () {
                };
            }
            if (typeof cancel !== "function") {
                cancel = function () {
                };
            }

            //设置信息
            titleEL.innerText = title ? title : '';
            contentEL.innerHTML = text ? text : '';
            cancelEl.innerText = cancelText ? cancelText : '取消';
            confirmEl.innerText = confirmText ? confirmText : '确定';
            if(isAlert){
                dialogBoxEl.querySelector('.act-dialog-bt-cancel').classList.add('hide');
            }

            //设置样式
            if(className){
                dialogEl.classList.add(className);
            }


            //显示
            show();

            confirmEl.addEventListener('click', funcConfirm);

            cancelEl.addEventListener('click', funcCancel);
            closeEl.addEventListener('click', close);
            maskEl.addEventListener('click', close);

            // 确认
            function funcConfirm() {
                confirm();
                close();
            }


            // 取消
            function funcCancel() {
                cancel();
                close();
            }

            function show() {

                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                    //移除样式
                    if(className){
                        dialogEl.classList.remove(className);
                    }
                }, 230);

                //移除事件
                confirmEl.removeEventListener('click', funcConfirm);

                cancelEl.removeEventListener('click', funcCancel);
                closeEl.removeEventListener('click', close);
                maskEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },

        //发送文件弹窗
        dialogSedfile: function (text, email, confirm, cancel, title) {

            var _this = this;
            this.sedfileDialogBoxEl = document.querySelector('.act-sendfile-dialog');
            var dialogBoxEl = _this.sedfileDialogBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var contentEL = dialogBoxEl.querySelector('.dialog-content');
            var titleEL = dialogBoxEl.querySelector('.dialog-title');
            var confirmEl = dialogBoxEl.querySelector('.act-dialog-bt-confirm');
            var cancelEl = dialogBoxEl.querySelector('.act-dialog-bt-cancel');
            var closeEl = dialogBoxEl.querySelector('.act-dialog-close');
            var inputEl = dialogBoxEl.querySelector('.dialog-input>input');
            var errorEl = dialogBoxEl.querySelector('.dialog-input-error');


            if (typeof confirm !== "function") {
                confirm = function () {
                };
            }
            if (typeof cancel !== "function") {
                cancel = function () {
                };
            }

            //移除错误红框
            inputEl.classList.remove('input_error');

            //设置信息
            titleEL.innerText = title ? title : '';
            if(text){
                contentEL.innerText = text;
            }
            inputEl.value = email;

            //显示
            show();

            confirmEl.addEventListener('click', send);

            closeEl.addEventListener('click', close);
            maskEl.addEventListener('click', close);

            //监听邮箱输入框
            inputEl.addEventListener('keyup', verificationEmail);

            //确认发送
            function send() {
                if(!verificationEmail(inputEl.value)){
                    return;
                }
                confirm(inputEl.value);
                close();
            }

            //验证邮箱
            function verificationEmail() {
                var email = inputEl.value;
                if(!email.match(/^\w+[\w\-\.]*@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]{2,})+$/)){
                    errorEl.style.display = 'block';
                    inputEl.classList.add('input_error');
                    return false;
                }else{
                    errorEl.style.display = 'none';
                    inputEl.classList.remove('input_error');
                    return true;
                }
            }

            function show() {

                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                    errorEl.style.display = 'none';
                }, 230);

                //移除事件
                confirmEl.removeEventListener('click', send);
                closeEl.removeEventListener('click', close);
                maskEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },


        //发送文件成功toast
        toastSedfile: function (text1, text2, time) {
            var _this = this;
            _this.sedfileToastBoxEl =  document.querySelector('.act-sendfile-toast-box');
            var toastBoxEl = _this.sedfileToastBoxEl;
            var toastContentEL1 = toastBoxEl.querySelector('.text-line-one');
            var toastContentEL2 = toastBoxEl.querySelector('.text-line-two');

            var s = time || 1500;

            if(text1){
                toastContentEL1.innerText = text1;
                toastContentEL2.innerText = text2 || '';
            }

            show();

            setTimeout(function () {
                close();
            }, s);

            function show() {
                toastBoxEl.style.display = 'block';
                toastBoxEl.classList.remove('dialog-mask-ani-fade-out');
                toastBoxEl.classList.add('dialog-mask-ani-fade-in');
            }

            function close() {
                toastBoxEl.classList.remove('dialog-mask-ani-fade-in');
                toastBoxEl.classList.add('dialog-mask-ani-fade-out');
                setTimeout(function () {
                    toastBoxEl.style.display = 'none';
                }, 230);
            }

        },

        //预览文件弹窗
        filePreviewDialog: function (url, title, needLogin, articleId, fileIds, fileName, articleUrl, isJump, hiddenDown, wHeight, previewUrl, leftPageNum) {
            var _this = this;
            var dialogBoxEl = _this.filePreviewBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog-filepre-content');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var titleEL = dialogBoxEl.querySelector('.file-action-bar>.title>a>h2');
            var titleLinkEL = dialogBoxEl.querySelector('.file-action-bar>.title>a');
            var closeEl = dialogBoxEl.querySelector('.closeicon');
            var iframeEl = dialogBoxEl.querySelector('.file-preview-box>iframe');
            var collectionEl = dialogBoxEl.querySelector('.collectionicon');
            var likeIconEl = dialogBoxEl.querySelector('.like-icon');
            var downEl = dialogBoxEl.querySelector('.downicon');
            var pageNumEl = dialogBoxEl.querySelector('.file-page-num');
            var bottomBar = dialogBoxEl.querySelector('.file-action-bottom-bar');

            //动态设置iframe内容高度
            var iframeBoxEl = dialogBoxEl.querySelector('.file-preview-box');
            var h = window.innerHeight * 0.75;
            if(wHeight){
                iframeBoxEl.style.height = wHeight + 'rem';
            }else{
                iframeBoxEl.style.height = h + 'px';
            }

            //如果articleId 不存在则隐藏点赞按钮
            if(!articleId){
                likeIconEl.classList.add('hide');
            }

            if(hiddenDown === '1'){
                downEl.classList.add('hide');
            }else{
                downEl.classList.remove('hide');
            }

            if(leftPageNum){
                pageNumEl.innerText = leftPageNum;
            }
            // 判断是否显示底部的剩余页数 需要登录 未登录 包含预览链接 剩余页数不为0
            if(needLogin && !isLogin() && previewUrl && parseInt(leftPageNum)){
                bottomBar.style.display = 'block';
                iframeEl.setAttribute('src', previewUrl);
            }else{
                bottomBar.style.display = 'none';
                iframeEl.setAttribute('src', url);
            }


            //设置点赞状态
            getCollectionStatus(articleId, collectionEl);

            //添加点赞事件
            likeIconEl.addEventListener('click', addLikeEvent);

            //点赞事件
            function addLikeEvent() {
                addLike(articleId, title, true);
            }

            //设置信息
            if(title === '0'){
                title = '';
            }
            titleEL.innerText = title ? title : '';

            //设置标题跳转链接
            if(isJump === 'n') {
                isJump = false;
            }else{
                isJump = true;
            }

            if(!isJump){
                titleLinkEL.setAttribute('href', 'javascript:void(0)');
            }else if(articleUrl){
                titleLinkEL.setAttribute('href', articleUrl);
            }else if(articleId && articleId !== '0'){
                titleLinkEL.setAttribute('href', window.urlConfig.type + window.urlConfig.baseUrl + '/view-' + articleId + '.html');
            }else{
                titleLinkEL.setAttribute('href', 'javascript:void(0)');
            }



            //显示
            show();

            closeEl.addEventListener('click', close);
            maskEl.addEventListener('click', close);

            downEl.addEventListener('click' , down);

            // 下载
            function down() {
                filelist.download(fileIds, articleId,title, needLogin, fileName);
            }

            function show() {

                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                    //关闭后将url置空
                    iframeEl.setAttribute('src', '');
                    titleLinkEL.setAttribute('href', 'javascript:void(0)');
                }, 230);

                //移除事件
                closeEl.removeEventListener('click', close);
                maskEl.removeEventListener('click', close);
                downEl.removeEventListener('click' , down);
                likeIconEl.removeEventListener('click', addLikeEvent);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },

        //预览视频弹窗
        videoDialog: function (url, title, articleId, articleUrl,autoCloseTime, noRecord) {
            var _this = this;
            var dialogBoxEl = _this.videoBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog-video-content');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var titleEL = dialogBoxEl.querySelector('.video-action-bar>.title>a>h2');
            var titleLinkEL = dialogBoxEl.querySelector('.video-action-bar>.title>a');
            var closeEl = dialogBoxEl.querySelector('.closeicon');
            // var videoEl = dialogBoxEl.querySelector('.video-box>video');
            var videoBoxEl = dialogBoxEl.querySelector('.video-box');
            var collectionEl = dialogBoxEl.querySelector('.collectionicon');
            var likeIconEl = dialogBoxEl.querySelector('.like-icon');

            var videoEl = document.createElement('video');
            videoEl.setAttribute('autoplay','true');
            videoEl.setAttribute('webkit-playsinline','true');
            videoEl.setAttribute('playsinline','true');
            videoEl.setAttribute('controls','');
            // videoEl.setAttribute('muted','');
            videoEl.setAttribute('src',url);
            videoBoxEl.append(videoEl);

            //设置点赞状态
            getCollectionStatus(articleId, collectionEl);

            //如果articleId 不存在则隐藏点赞按钮
            if(!articleId){
                likeIconEl.classList.add('hide');
            }

            //添加点赞事件
            likeIconEl.addEventListener('click', addLikeEvent);

            //点赞事件
            function addLikeEvent() {
                addLike(articleId, title, true);
            }

            var timer = null;
            //自动关闭时间
            if (autoCloseTime){
                timer = setInterval(function () {
                    if (Math.round(videoEl.currentTime) == parseInt(autoCloseTime)){
                        close();
                    }
                },1000);
            }

            //设置信息
            titleEL.innerText = title ? title : '';
            // videoEl.setAttribute('src', url);

            //设置标题跳转链接
            if(articleUrl){
                titleLinkEL.setAttribute('href', articleUrl);
            }else if(articleId){
                titleLinkEL.setAttribute('href', window.urlConfig.type + window.urlConfig.baseUrl + '/view-' + articleId + '.html');
            }else{
                titleLinkEL.setAttribute('href', 'javascript:void(0)');
            }


            //显示
            show();

            closeEl.addEventListener('click', close);
            maskEl.addEventListener('click', close);

            function show() {

                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                videoEl.play();

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                if (timer) { clearInterval(timer) };
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                    videoEl.setAttribute('src', '');
                    videoEl.remove();
                }, 230);

                videoEl.pause();
                if (!noRecord) {
                    gioTrackAction.cloudEndPlayVideo(videoEl.currentTime || 0, articleId, title);
                }
                titleLinkEL.setAttribute('href', 'javascript:void(0)');

                likeIconEl.removeEventListener('click', addLikeEvent);
                closeEl.removeEventListener('click', close);
                maskEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },

        /**
         * 议价单
         * @param productInfo 产品信息
         * @param formConfig 表单配置
         * @param gioClickEvent gio点击事件标识符
         */
        batchDialog: function (productInfo, formConfig, gioClickEvent) {
            var _this = this;
            if(gioClickEvent){
                gio('track', gioClickEvent);
            }

            //如果没有传过来配置，则用批量议价单的配置
            var formConfig = formConfig ||  window.cateData.batchFrome;

            //设置产品信息
            var productInfoDef = {
                productName: '',
                productImgUrl:'',
                productDesc:'',
                productnum: '1',
                productnumLimit: '9999',
                productSale: '',
                productPrice: '',
                productId: '',
            };
            var info = baseExtend(productInfoDef, productInfo);

            //获取元素
            _this.bargainEl = document.querySelector('.act-dialog-bargain-box');
            var dialogBoxEl = _this.bargainEl;
            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var confirmEl = dialogBoxEl.querySelector('.act-dialog-bt-confirm');
            var closeEl = dialogBoxEl.querySelector('.act-dialog-close');
            //产品信息元素
            var productBoxEl = dialogBoxEl.querySelector('.product-box');
            var productNameEl = dialogBoxEl.querySelector('.product-name');
            var productImgEl = dialogBoxEl.querySelector('.product-img>img');
            var productDescEl = dialogBoxEl.querySelector('.product-dec');
            var productPriceNameEl = dialogBoxEl.querySelector('.item-name-price');
            var productSaleEl = dialogBoxEl.querySelector('.product-sale');
            var productPriceEl = dialogBoxEl.querySelector('.product-price');
            var productTypeEl = dialogBoxEl.querySelector('.product-type');
            var productcontactEl = dialogBoxEl.querySelector('.product-contact-dell');
            var formTitleEl = dialogBoxEl.querySelector('.bargain-title');
            var formDescEl = dialogBoxEl.querySelector('.bargain-dec');
            var formBoxEl = dialogBoxEl.querySelector('.bargain-form-box');

            var kefuEl = dialogBoxEl.querySelector('.act-kefu');

            var contentEL = dialogBoxEl.querySelector('.dialog-content');
            if (!productInfo) {
                contentEL.setAttribute('style','height: 65vh');
            } else if (productInfo && !productInfo.productId){
                contentEL.setAttribute('style','height: 65vh');
            }

            if (typeof confirm !== "function") {
                confirm = function () {
                };
            }

            // 自定义提交按钮背景颜色
            if (formConfig.submitBGColor){
                confirmEl.setAttribute('style', 'background:' + formConfig.submitBGColor);
            } else {
                confirmEl.setAttribute('style', 'background:#f2af29');
            }

            // 设置标题，描述
            formTitleEl.innerText = formConfig.formName;
            if (formConfig.formDesc) {
                formDescEl.innerHTML = formConfig.formDesc;
            }

            //初始化数量选择
            var shopNum = new ProductNumCtr('.dialog-num-cut', '.dialog-num', '.dialog-num-add', info.productnumLimit);
            shopNum.setNum(parseInt(info.productnum));

            if (productInfo && productInfo.productId) {
                //设置信息
                productNameEl.innerText = info.productName;
                productImgEl.setAttribute('src', info.productImgUrl);
                productImgEl.setAttribute('alt', info.productName);
                productDescEl.innerText = info.productDesc;
                if (info.productType && info.productType.length > 0) {
                    //
                    var productTypeBoxEl = dialogBoxEl.querySelector('.product-item-type');
                    var hideIndex = productTypeBoxEl.className.indexOf('hide');
                    if (hideIndex != -1) {
                        productTypeBoxEl.className = productTypeBoxEl.className.split('hide').join('');
                    }
                    productTypeEl.innerHTML = info.productType;
                }
                //判断价格
                if(info.productSale && info.productPrice){
                    productPriceNameEl.innerText = '促销价格';
                    productSaleEl.innerText = info.productSale;
                    productPriceEl.innerText = info.productPrice;
                }else if(info.productSale){
                    productPriceNameEl.innerText = '促销价格';
                    productSaleEl.innerText = info.productSale;
                    productPriceEl.classList.add('hide');
                }else if(info.productPrice){
                    productPriceNameEl.innerText = '参考价格';
                    productSaleEl.innerText = info.productPrice;
                    productPriceEl.classList.add('hide');
                }else{
                    productPriceNameEl.innerText = '参考价格';
                    productSaleEl.classList.add('hide');
                    productPriceEl.classList.add('hide');
                    productcontactEl.classList.remove('hide');
                    productcontactEl.addEventListener('click', function () {
                        nav.changeNav(event, 'form', {
                            'productname':info.productName,
                            'productid':info.productId,
                            'productprice':info.productSale?info.productSale:info.productPrice,
                            'productnum': shopNum.getNum(),
                            'entrance':info.productName + '/' + info.productId
                        });
                    });
                }
            }else {
                //  如果没有产品信息，隐藏产品UI
                productBoxEl.setAttribute('style','display:none');
                formBoxEl.setAttribute('style','margin-top: .4rem');
            }

            //显示弹窗
            show();

            //绑定事件
            closeEl.addEventListener('click', close);
            maskEl.addEventListener('click', close);
            confirmEl.addEventListener('click', send);
            kefuEl.addEventListener('click', openKefu);

            // 初始化表单
            var formName = new fieldHandle.HandelValue('dialogName', 'dialogNameV','dialogNameVE', 'form-error', '请输入姓名');
            var formMobile = new fieldHandle.HandelValue('dialogMobile', 'dialogMobileV','dialogMobileVE','form-error', '请输入手机', '输入正确的手机号', baseVerif.isMobile);
            var formEmail = new fieldHandle.HandelValue('dialogEmail', 'dialogEmailV','dialogEmailVE','form-error', '请输入邮箱', '输入正确的邮箱', baseVerif.isEmail);
            var formCompName = new fieldHandle.HandelValue('dialogCompName','dialogCompV','dialogCompVE','form-error', '请输入公司名称');
            var formIfwish = new fieldHandle.HandelRadioVerif('ifWish', 'dialogIfWishVE');

            //设置表单默认值
            formName.set(getUserInfo.options.name || '');
            formMobile.set(getUserInfo.options.mobile || '');
            formEmail.set(getUserInfo.options.email || '');
            formCompName.set(getUserInfo.options.enterpriseName || '');
            formIfwish.setNull();

            function openKefu() {
                // common.productOpenKefu(info.productId);
                qidiankefu.open('',{
                    productId :info.productid
                });
            }

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                closeEl.removeEventListener('click', close);
                maskEl.removeEventListener('click', close);
                confirmEl.removeEventListener('click', send);
                kefuEl.removeEventListener('click', openKefu);
                if (shopNum) {
                    shopNum.destroy();
                }
                shopNum = null;


                //允许后方滚动
                common.setScroll.removeUnScroll();
            }

            //确认发送
            function send() {
                //进行验证
                formName.change();
                formMobile.change();
                formEmail.change();
                formCompName.change();
                formIfwish.change();
                if(formName.isVerif && formMobile.isVerif && formEmail.isVerif && formCompName.isVerif && formIfwish.isVerif){
                    //进行验证

                    var url = window.cateData.api.actionForm;
                    var parainfo = {
                        customFormId:formConfig.formId,
                        globalUserId:getUserInfo.options.globalUserId,
                        instanceId:'',
                        items:[
                            {fieldName: "enterprise_name", value: formCompName.get()},
                            {fieldName: "name", value: formName.get()},
                            {fieldName: "mobile", value: formMobile.get()},
                            {fieldName: "email", value: formEmail.get()},
                            {fieldName: "ifWish", value: formIfwish.get()},
                            {fieldName: formConfig.customFilds.productName, value: info.productName},
                            {fieldName: formConfig.customFilds.productId, value: info.productId},
                            {fieldName: formConfig.customFilds.productPrice, value: info.productSale?info.productSale:info.productPrice},
                            {fieldName: formConfig.customFilds.productNum, value: shopNum.getNum()},
                            {fieldName: formConfig.customFilds.linkSourceModule, value: (window.cateData.userRecordOption &&  window.cateData.userRecordOption.module )? window.cateData.userRecordOption.module : ''},
                            {fieldName: formConfig.customFilds.pagetitle, value: document.title},
                            {fieldName: "linksource", value: window.location.href},
                        ],
                        linkId:'',
                        sess: window.cateData.userInfo.sess,
                        referenceUrl:'',
                        url:window.location.href,
                        ver: "v2.0.1",
                    };
                    postJson(url, parainfo, function (data) {
                        var userR = {behaviorType: formConfig.behaviorType};
                        if(data.body.result === 0){
                            userR['behaviorResult'] = info.productName;
                            if (formConfig.entrance){
                                userR['entrance'] = formConfig.entrance;
                            }
                            solution_wap_msg.toastSedfile('提交成功！', '请等待戴尔销售专家与您联系');
                            userRecord(userR);
                            if (formConfig.gioType) {
                                gio('track', formConfig.gioType, {'ibuyEntrancePageTitle': document.title, 'ibuyEntrancePageURL': document.URL, 'productID':info.productId, 'productname':info.productName, 'linkSourceurl': window.location.href,'phoneNumber': common.mobileEncryption(formMobile.get())});  //埋点实施方案
                            }
                        }else{
                            solution_wap_msg.toast('提交失败,请稍后再试');
                            userR['behaviorResult'] = "提交失败";
                            userRecord(userR);
                        }
                    });
                    close();
                }
            }
        },

        // 公用项目咨询配置
        /**
         *
         * @param gioClickEvent gio点击事件标识符
         * @constructor
         */
        ProjectConsultingDialog: function(gioClickEvent){
            var _this = this;
            _this.batchDialog(null, window.cateData.purchaseIntentionForm, gioClickEvent);
        },

        //验证码登录弹窗
        dialogLoginWithCode: function (code, confirm, title) {

            var _this = this;
            var dialogBoxEl = _this.loginWithCodeBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var titleEL = dialogBoxEl.querySelector('.dialog-content');
            var confirmEl = dialogBoxEl.querySelector('.act-dialog-bt-confirm');
            var inputEl = dialogBoxEl.querySelector('.dialog-input>input');
            var errorEl = dialogBoxEl.querySelector('.dialog-input-error');


            if (typeof confirm !== "function") {
                confirm = function () {
                };
            }

            //移除错误红框
            inputEl.classList.remove('input_error');

            //设置信息
            titleEL.innerText = title ? title : '';

            // inputEl.value = code;

            //显示
            show();

            confirmEl.addEventListener('click', send);

            //监听邮箱输入框
            inputEl.addEventListener('keyup', verificationCode);

            //确认发送
            function send() {
                if(!verificationCode(inputEl.value)){
                    return;
                }
                confirm(inputEl.value);
                close();
            }

            //验证验证码是否正确
            function verificationCode() {
                var inputcode = inputEl.value;
                if (inputcode.toUpperCase() == code.toUpperCase()){
                    errorEl.style.display = 'none';
                    inputEl.classList.remove('input_error');
                    return true;
                }else{
                    errorEl.style.display = 'block';
                    inputEl.classList.add('input_error');
                    return false;
                }
            }

            function show() {

                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                    errorEl.style.display = 'none';
                }, 230);

                //移除事件
                confirmEl.removeEventListener('click', send);
                maskEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },

        //底部上拉菜单
        dialogList: function (type) {

            var _this = this;
            var dialogBoxEl = _this.upPullList;

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var contentEL = dialogBoxEl.querySelector('.dialog-list');

            if(dialogBoxEl.style.display === 'flex' || type === 'close'){
                close();
            }else{
                show();
            }
            //显示

            maskEl.addEventListener('click', close);
            dialogEl.addEventListener('click', close);

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-bottom');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-bottom');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-bottom');
                dialogEl.classList.add('dialog-ani-to-bottom');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);
                maskEl.removeEventListener('click', close);
                dialogEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },

        dialogPorductSelect: function (productInfo) {
            //设置产品信息
            var productInfoDef = {
                productName: '无内容',
                productImgUrl:'/catalog/view/theme/default/img/productimgdef.png',
                productDesc:'无内容',
                productTypes: []
            };
            var info = baseExtend(productInfoDef, productInfo);

            //获取元素
            var dialogBoxEl = this.productTypeSelectEl;
            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var closeEl = dialogBoxEl.querySelector('.close-button');

            //产品信息元素
            var productNameEl = dialogBoxEl.querySelector('.product-title');
            var productImgEl = dialogBoxEl.querySelector('.product-pic>img');
            var productDescEl = dialogBoxEl.querySelector('.product-desc');
            var productTypesBox = dialogBoxEl.querySelector('.product-types');

            //设置信息
            productNameEl.innerText = info.productName;
            productImgEl.setAttribute('src', info.productImgUrl);
            productImgEl.setAttribute('alt', info.productName);
            productDescEl.innerText = info.productDesc;
            productTypesBox.innerHTML = '';

            if (info.productTypes){
                info.productTypes.forEach(function (obj, index) {
                    var productType = document.createElement('div');
                    productType.className = 'product-type-item';
                    productType.innerText = obj.title;
                    (function (product) {
                        productType.addEventListener('click', function(){
                            if (productInfo.typeClickFun) {
                                productInfo.typeClickFun();
                            }
                            window.location.href = product.link;
                        });
                    })(obj)
                    productTypesBox.appendChild(productType);
                })
            }

            //绑定事件
            closeEl.addEventListener('click', close);
            maskEl.addEventListener('click', close);

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                closeEl.removeEventListener('click', close);
                maskEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }

            show();
        },

        //秒杀弹窗
        miaoShaDialog: function (msDetailId) {
            var _this = this;
            var dialogBoxEl = _this.miaoShaEl;
            var dialogEl = dialogBoxEl.querySelector('.m-miaosha-content');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var closeEl = dialogBoxEl.querySelector('.m-ms-close');
            var qiangGouEl = dialogBoxEl.querySelector('.ms-qianggou-btn');
            var codeEl = dialogBoxEl.querySelector('.miaosha-code');
            var errorTipsEl = dialogBoxEl.querySelector('.ms-error-tip');
            var successCon = dialogBoxEl.querySelector('.j-successCon');
            var failCon = dialogBoxEl.querySelector('.j-failCon');
            var codeCon = dialogBoxEl.querySelector('.j-codeCon');

            closeEl.addEventListener('click', close);
            qiangGouEl.addEventListener('click', qiangGou);

            show();
            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();

                //gio 埋点
                try {
                    gio('track', 'double12miaoshabutton_click', {'consultEntrancePage': document.title, 'consultEntrancePageURL': document.URL})
                }catch (e) {
                    console.log(e)
                }
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');

                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                closeEl.removeEventListener('click', close);
                maskEl.removeEventListener('click', close);
                qiangGouEl.removeEventListener('click', qiangGou);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }

            var isSubmitting = false;
            function qiangGou() {
                if (isSubmitting) return;
                if (codeEl.value == '') {
                    errorTipsEl.innerText = '请输入兑换码';
                    return;
                }
                isSubmitting = true;
                errorTipsEl.innerText = '';
                var url = '/api/miaosha/doaward?award_id=' + msDetailId + '&code=' + codeEl.value;
                getJson(url, '', function (data) {
                    isSubmitting = false;
                    if (data.errCode == '0') {
                        codeCon.style.display = 'none';
                        successCon.style.display = 'block';
                    } else if (data.errCode == '40101') {
                        errorTipsEl.innerText = '您的兑换码输入有误，请重新输入';
                    } else if (data.errCode == '40102') {
                        errorTipsEl.innerText = '您的抢购码已被兑换，不可重复使用';
                    } else {
                        codeCon.style.display = 'none';
                        failCon.style.display = 'block';
                    }
                    if(app){
                        app.getInfo();
                    }
                });
            }
        },

        //提示窗
        relatedDialog: function (title, highLight, imgUrl, price, confirm, closeFunc) {

            var _this = this;
            var dialogBoxEl = _this.relatedEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var highlinghtEl = dialogBoxEl.querySelector('.highlinght');
            var priceEl = dialogBoxEl.querySelector('.price-content');
            var titleEl = dialogBoxEl.querySelector('.title');
            var confirmEl = dialogBoxEl.querySelector('.act-dialog-bt-confirm');
            var closeEl = dialogBoxEl.querySelector('.act-dialog-close');
            var countBoxEl = dialogBoxEl.querySelector('.dialog-close-time');
            var countEl = countBoxEl.querySelector('.count-time');


            if (typeof confirm !== "function") {
                confirm = function () {
                };
            }

            if (typeof closeFunc !== "function") {
                closeFunc = function () {
                };
            }

            //设置信息
            titleEl.innerHTML = title ? title : '';
            highlinghtEl.innerHTML = highLight ? highLight : '';
            priceEl.innerHTML = price ? price : '联系戴尔';
            dialogBoxEl.querySelector('.prod-img img').src = imgUrl;


            //显示
            show();

            confirmEl.addEventListener('click', funcConfirm);
            maskEl.addEventListener('click', close);
            closeEl.addEventListener('click', close);

            if (getUserInfo.getUserTeam() == 4 || getUserInfo.getUserTeam() == 5) {
                closeEl.style.display = 'none';
                countBoxEl.style.display = 'block';
                var timer = setInterval(function () {
                    var curTime = countEl.innerText;
                    if (curTime <= 1) {
                        close();
                        clearInterval(timer);
                    } else {
                        countEl.innerText = curTime - 1;
                    }
                }, 1000);
            }

            // 确认
            function funcConfirm() {
                confirm();
                close();
            }

            function show() {

                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                //移除事件
                confirmEl.removeEventListener('click', funcConfirm);
                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();

                closeFunc();
            }
        },

        dialogDtf: function (opt) {

            var text = opt.title || '',
                desc = opt.desc || '',
                showCloseBtn = opt.showCloseBtn || true,
                linkText = opt.linkText || '',
                linkUrl = opt.linkUrl  || 'javascript:void(0)',
                linkTarget = opt.openNew?'_blank':'self',
                className = opt.className || '',
                icon = opt.icon || '/catalog/view/theme/default/img/layer-wait-pic.png',
                closeFunc = opt.closeFunc || '';



            var _this = this;

            //获取元素
            var dialogBoxEl = document.querySelector('.act-dialog-box-dtf');
            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var closeEl = dialogBoxEl.querySelector('.act-dialog-close');
            var linkEl = dialogBoxEl.querySelector('.btn-link');
            var iconEl = dialogBoxEl.querySelector('.dialog-icon img');

            if(!showCloseBtn){
                closeEl.style.display = 'none';
            }

            linkEl.innerHTML = linkText;
            linkEl.setAttribute('href', linkUrl);
            linkEl.setAttribute('target', linkTarget);
            iconEl.setAttribute('src', icon);

            if(className){
                dialogBoxEl.classList.add(className);
            }

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                if (text) {
                    var titleEL = dialogEl.querySelector('.text-big');
                    titleEL.innerHTML = text;
                }

                var descEL = dialogEl.querySelector('.text-desc');
                if (desc) {
                    descEL.style.display = '';
                    descEL.innerHTML = desc;
                }else{
                    descEL.style.display = 'none';
                }

                if(showCloseBtn){
                    maskEl.addEventListener('click', close);
                    closeEl.addEventListener('click', close);
                }

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();

                if (typeof closeFunc === "function") {
                    closeFunc();
                }
            }

            function goHome() {
                window.location.href = window.rootUrl;
            }

            common.setScroll.show();

            return {
                'close': close
            }
        },

        /**
         * webinar2020 口令弹窗
         * @param password 口令密码
         */
        webinar2020Dialog: function () {
            var _this = this;
            var dialogBoxEl = _this.meetingsEl;

            var dialogEl = dialogBoxEl.querySelector('.meetings-box');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var closeEl = dialogBoxEl.querySelector('.webinar-box-close');
            var errorEl = dialogBoxEl.querySelector('.error-tip');

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');
                errorEl.innerHTML = '';
                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }

            closeEl.addEventListener('click', close);
            maskEl.addEventListener('click', close);

            //显示
            show();
        },

        // 推荐标签弹窗
        recommendTagDialog: function () {
            var _this = this;
            var dialogBoxEl = _this.recommendTagBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var confirmEl = dialogBoxEl.querySelector('.dialog-bt-confirm');
            var closeEl = dialogBoxEl.querySelector('.dialog-bt-cancel');
            var tagBoxEl = dialogBoxEl.querySelector('.dialog-content .scroll-view');

            if (!common.isLogin()) {
                return common.gotoLogin();
            }

            // 初始化表单
            var formMobile = new fieldHandle.HandelValue('dialogCompleteMobile', 'dialogCompleteMobileV', 'dialogCompleteMobileVE', 'form-error', '请输入手机号', '输入正确的手机号', baseVerif.isMobile);
            var formCompanyEmail = new fieldHandle.HandelValue('dialogCompleteCompanyEmail', 'dialogCompleteCompanyEmailV', 'dialogCompleteCompanyEmailVE', 'form-error', '请输入企业邮箱', '输入正确的企业邮箱', baseVerif.isEmail);

            //设置表单默认值
            formMobile.set(getUserInfo.options.mobile || '');
            formCompanyEmail.set(getUserInfo.options.email || '');

            tagsData().then(function () {
                // 显示
                show();
                gioTrackAction.gio_base('popupImp', {'popupType_var': '订阅兴趣弹窗'});
                // 点击标签 切换选中的样式
                $('.recommend-tag-dialog .scroll-view .label').click(function () {
                    $(this).toggleClass('label-selected');
                });
            });

            confirmEl.addEventListener('click', funcConfirm);
            maskEl.addEventListener('click', close);
            closeEl.addEventListener('click', close);

            // 标签数据
            function tagsData() {
                var def = $.Deferred();
                var info = {
                    OCSESSID: common.isLogin() ? common.isLogin().OCSESSID : '',
                    session: common.isLogin() ? common.isLogin().session : '',
                };
                var tagStr = '';

                common.getJson(solution_host + '/api/account/tag', info, function (res) {
                    if (common.getSS('recommend_tag_list', true)) {
                        // 登录后返回，回填选中的标签
                        res.data.forEach(function(item) {
                            item.tag.forEach(function (tag) {
                                common.getSS('recommend_tag_list', true).forEach(function (ss_tag) {
                                    if (tag.id == ss_tag) {
                                        tag.select = true;
                                    }
                                })
                            });
                        });
                        sessionStorage.removeItem('recommend_tag_list');
                    }
                    res.data.forEach(function(item) {
                        tagStr += '<section class="filter-list__module" id="'+ item.summary +'"><div class="module-list__title">' + item.title +'</div>' + '<ul class="module-list">';
                        item.tag.forEach(function (tag) {
                            tagStr += '<li class="module-list__item"><div data-id="' + tag.id + '" class="label ' + (tag.select ? 'label-selected' : '') +'">' + tag.title + '</div></li>'
                        });
                        tagStr += '</ul></section>';
                    });
                    tagBoxEl.innerHTML = tagStr;
                    def.resolve();
                });
                return def;
            }

            // 确认
            function funcConfirm() {
                var tagIdList = $('.recommend-tag-dialog .scroll-view .label-selected').map(function(){
                    return ($(this).attr('data-id'));
                }).get();
                if (!common.isLogin()) {
                    if (tagIdList.length > 0) {
                        common.setSS('recommend_tag_list', tagIdList, true);
                    }
                    return common.gotoLogin();
                }
                if (tagIdList.length === 0) return msg.toast('请选择标签');
                //进行验证
                formMobile.change();
                formCompanyEmail.change();

                if (formMobile.isVerif && formCompanyEmail.isVerif) {
                    // 处理埋点数据
                    var productsName =  $('#interestProductMA .label-selected').map(function(){
                        return ($(this).text());
                    }).get().join(',');
                    var solutionName =  $('#interestSolutionMA .label-selected').map(function(){
                        return ($(this).text());
                    }).get().join(',');
                    var allTagsName =   $('.recommend-tag-dialog .scroll-view .label-selected').map(function(){
                        return ($(this).text());
                    }).get().join(',');


                    gioTrackAction.gio_base('interestSubmit', {'interestProduct':productsName, 'interestSolution':solutionName, 'subType':''});
                    userAction.interestTagSelect(allTagsName);

                    common.postJson(solution_host + '/api/account/likeTag', {
                        session: common.isLogin() ? common.isLogin().session : '',
                        OCSESSID: common.isLogin() ? common.isLogin().OCSESSID: '',
                        tag: tagIdList,
                        email: formCompanyEmail.value,
                        mobile: formMobile.value,
                        source: 'wap'
                    }, function (res) {
                        common.setCookie('recommend_tag', true);
                    });
                    close();
                    window.solution_wap_msg.recommendTagSuccessDialog();
                }
            }

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                //移除事件
                confirmEl.removeEventListener('click', funcConfirm);
                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },

        // 推荐标签成功后弹窗
        recommendTagSuccessDialog: function () {
            var _this = this;
            var dialogBoxEl = _this.recommendTagSuccessBoxEl;
            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var closeEl = dialogBoxEl.querySelector('.dialog-close');

            // 显示
            show();
            maskEl.addEventListener('click', close);
            closeEl.addEventListener('click', close);

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                //移除事件
                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },

        // 订阅计划开启弹窗
        subscribePlanDialog: function (type) {
            var _this = this;
            var dialogBoxEl = _this.subscribePlanBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var dialogBtn = dialogBoxEl.querySelector('.dialog-btn');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var closeEl = dialogBoxEl.querySelector('.dialog-close');

            dialogBoxEl.querySelector('.dialog-img').src = window.solution_host + '/static/pc/img/public/dialog/recommend-dialog/recommend-tips-24718' + (type === 'C' ? '-xcx.png' : '.png');

            show();

            closeEl.addEventListener('click', close);
            maskEl.addEventListener('click', close);
            dialogBtn && dialogBtn.addEventListener('click', type === 'C' ? goXcx : goCampaign);

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                // 订阅计划已弹出
                common.setCookie('subscribePlanClick_20260226', 1, 365);
                gioTrackAction.gio_base('popupClose', {
                    "in_app_message_name": "会员礼遇" + type + "类弹窗"
                });

                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                //移除事件
                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }

            function goXcx() {
                close();
                gioTrackAction.gio_base('PopUp_HuiyuanLiyu_Button', {
                    "in_app_message_name": "会员礼遇C类弹窗"
                });
                common.gotoUrl('https://www.dellemc-solution.com/campaign/jump-xcx?path=pages%2Fauth%2Flogin&query=utm_source%3Dsolutioncom%26utm_medium%3Dot_md_so%26utm_campaign%3Dmember_ellis-ma-0130%26utm_content%3Dmona-li%26utm_term%3Dma-0130-tanchuang-c%26backUrl%3D%2Fpages%2Fintegral%2Findex');
            }

            function goCampaign() {
                close();
                gioTrackAction.gio_base('PopUp_HuiyuanLiyu_Button', {
                    "in_app_message_name": "会员礼遇D类弹窗"
                });
                window.location.href = window.solution_host + '/campaign/promotion'
            }
        },

        // 文章推荐弹窗
        recommendArticleDialog: function () {
            var _this = this;
            var swiper_new;
            var dialogBoxEl = _this.recommendArticleBoxEl;

            var dialogEl = dialogBoxEl.querySelector('.dialog');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var closeEl = dialogBoxEl.querySelector('.dialog-close');
            var swiperBoxEl = dialogBoxEl.querySelector('.swiper-wrapper');



            articleData().then(function (res) {
                if(res.length === 0) return;
                // 显示
                show();
                // 初始化swiper
                initSwiper();
            });

            maskEl.addEventListener('click', close);
            closeEl.addEventListener('click', close);

            // 标签数据
            function articleData() {
                var def = $.Deferred();
                var info = {
                    OCSESSID: common.isLogin() ? common.isLogin().OCSESSID : '',
                    session: common.isLogin() ? common.isLogin().session : '',
                };
                var swiperStr = '';

                common.getJson(solution_host + '/api/account/tagArticle', info, function (res) {
                    console.log(res.data);
                    res.data.forEach(function(item) {
                        swiperStr += '<div class="swiper-slide">' +
                            '<div class="article-item">' +
                            '<a href="'+ item.linkUrl +'" target="_blank">' +
                            '<div class="cover-img">' +
                            '<img src="' + item.coverImageUrl +'" alt="">' +
                            '</div>' +
                            '<div class="article-title">' + item.title +'</div>' +
                            '</a>' +
                            '</div></div>';
                    });
                    swiperBoxEl.innerHTML = swiperStr;
                    def.resolve(res.data);
                });
                return def;
            }

            function initSwiper() {
                swiper_new = new Swiper('.recommend-article-dialog .article-swiper', {
                    slidesPerView: 2,
                    slidesPerColumn: 2,
                    slidesPerColumnFill: 'row',
                    slidesPerGroup: 4,
                    spaceBetween: 10,
                    observer:true,
                    observeParents:true,
                    autoHeight: true, //高度随内容变化
                    pagination: {
                        clickable: true,
                        el: '.swiper-recommend-pagination'
                    },
                })
            }

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');
                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                //移除事件
                maskEl.removeEventListener('click', close);
                closeEl.removeEventListener('click', close);


                //销毁swiper
                swiper_new.destroy(false);

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }
        },

        // 公众号登录，绑定手机号
        bindMobileDialog: function (successFunc) {
            var _this = this;
            var dialogBoxEl = _this.gzhBindMobile;
            var dialogEl = dialogBoxEl.querySelector('.bind-form');
            var maskEl = dialogBoxEl.querySelector('.dialog-mask');
            var codeBtnEl = dialogBoxEl.querySelector('.get-phone-code');
            var confirmEl = dialogBoxEl.querySelector('.bind-form-btn');
            var sending = false; // 短信发送中
            var downTime = 60; // 短信倒计时
            var submiting = false; // 点击提交

            // 显示
            show();

            confirmEl.addEventListener('click', submit);
            codeBtnEl.addEventListener('click', send);

            // 初始化表单
            var formMobile = new fieldHandle.HandelValue('dialogBindMobile', 'dialogBindMobileV', 'dialogBindMobileVE', 'form-error', '请输入手机号', '输入正确的手机号', baseVerif.isMobile);
            var formCode = new fieldHandle.HandelValue('dialogBindMobileCode', 'dialogBindMobileCodeV', 'dialogBindMobileCodeVE', 'form-error', '请输入验证码', '输入正确的验证码', baseVerif.isNum);

            function show() {
                dialogBoxEl.style.display = 'flex';
                maskEl.classList.remove('dialog-mask-ani-fade-out');
                dialogEl.classList.remove('dialog-ani-to-top');
                maskEl.classList.add('dialog-mask-ani-fade-in');
                dialogEl.classList.add('dialog-ani-from-top');

                //禁止后方滚动
                common.setScroll.unScroll();
            }

            function close() {
                maskEl.classList.remove('dialog-mask-ani-fade-in');
                maskEl.classList.add('dialog-mask-ani-fade-out');

                dialogEl.classList.remove('dialog-ani-from-top');
                dialogEl.classList.add('dialog-ani-to-top');

                setTimeout(function () {
                    dialogBoxEl.style.display = 'none';
                }, 230);

                confirmEl.removeEventListener('click', submit);
                codeBtnEl.removeEventListener('click', send);

                clearFomr();

                //允许后方滚动
                common.setScroll.removeUnScroll();
            }

            //清空表单对象
            function clearFomr() {
                //指控表单对象
                formMobile = null;
                formCode = null;
            }

            //发送验证码
            function send() {
                formMobile.change();
                if (formMobile.isVerif && !sending) {
                    //手机号验证通过
                    codeBtnEl.innerHTML = '发送中...';
                    codeBtnEl.classList.remove('pointer');
                    sending = true;

                    common.postJson(solution_host + '/api/sms/code/send',{
                        unique: formMobile.get(),
                        sign: common.getSendCodeSign(),
                        action: ''
                    },function (data) {
                        if (data.errCode === 0) {
                            downTime = 60;
                            var timer = setInterval(function () {
                                downTime--;
                                codeBtnEl.innerHTML = downTime + ' S';
                                if (downTime == 0) {
                                    codeBtnEl.innerHTML = '重新发送';
                                    codeBtnEl.classList.add('pointer');
                                    clearInterval(timer);
                                    timer = null;
                                    sending = false;
                                }
                            },1000)
                        } else {
                            msg.toast(data.msg);
                            codeBtnEl.innerHTML = '重新发送';
                            codeBtnEl.classList.add('pointer');
                            sending = false;
                        }
                    })
                }
            }

            //绑定手机号
            function submit() {
                //进行验证
                formMobile.change();
                formCode.change();

                submiting = true;
                confirmEl.innerHTML = '绑定中...';

                if (formMobile.isVerif && formCode.isVerif) {
                    submiting = true;
                    confirmEl.innerHTML = '绑定中...';
                    common.postJson(solution_host + '/api/account/loginandregister',{
                        "unique": formMobile.get(),
                        "checkCode": formCode.get(),
                        "unikey": localStorage.getItem('unikey'),
                        "url": window.location.href,
                        "globalUserId": common.getGlobalUserId(),
                        "moduleSource": common_utmObj.modulesources || '',
                        "utm_source": common_utmObj.utm_source || '',
                        "utm_medium": common_utmObj.utm_medium || '',
                        "utm_campaign": common_utmObj.utm_campaign || '',
                        "utm_content": common_utmObj.utm_content || '',
                        "utm_term": common_utmObj.utm_term || ''
                    }, function (data) {
                        submiting = false;
                        confirmEl.innerHTML = '绑定手机号';
                        if (data.errCode !== 0) return _this.toast(data.msg);
                        try {
                            // gio 埋码
                            var giouserinfo = data.data;
                            var gioParams = {
                                phone_ppl: common.mobileGioEncryption(data.data.mobile),
                            }
                            gio('setUserId', data.data.memberId);
                            gio('people.set',gioParams);
                            //cookie中设置一个用户手机
                            common.setCookie('dell_userName', data.data.name|| '', 5);
                            common.setCookie('dell_userMobile', common.mobileEncryption(data.data.mobile), 5);
                            common.setCookie('Activity_MOBILE','MOBILE'+ data.data.mobile +'number', 365);
                            gio('track', 'loginSuccess', {'user_Id': data.data.memberId, 'phoneNumber': common.mobileGioEncryption(data.data.mobile),'loginType':'微信扫码'})
                            _this.toast('绑定成功');
                            common.setCookie('smarketMember_498', JSON.stringify({
                                session: data.data.session,
                                memberId: data.data.memberId || '',
                                email: data.data.email || ''
                            }), 5);
                            common.setCookie('OCSESSID', data.data.OCSESSID, 5);
                        } catch (e) {
                            console.log(e);
                        }
                        setTimeout(function(){
                            window.location.reload();
                        },500)
                        localStorage.removeItem('unikey');
                        close();
                    });
                }
            }
        },
    };
});
